/**
 * Modular Verra Closet Configurator
 * Version: 1.0.1
 * Build: 5
 * Last Commit: 83de5cf
 * Build Date: 2025-09-01
 *
 * This file was automatically generated.
 * Do not edit the version header manually.
 */

import * as THREE from "three";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";

import { CSS2DRenderer } from "three/examples/jsm/renderers/CSS2DRenderer.js";
import {
  CSS3DRenderer,
  CSS3DObject,
} from "three/examples/jsm/renderers/CSS3DRenderer.js";

import { TextGeometry } from "three/addons/geometries/TextGeometry.js";
import { gsap } from "gsap";

import { OrbitControls } from "three/addons/controls/OrbitControls.js";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { RGBELoader } from "three/addons/loaders/RGBELoader.js";
import { GUI } from "three/addons/libs/lil-gui.module.min.js";

import { LineMaterial } from "three/examples/jsm/lines/LineMaterial.js";
import { Wireframe } from "three/examples/jsm/lines/Wireframe.js";
import { LineSegmentsGeometry } from "three/examples/jsm/lines/LineSegmentsGeometry.js";

import {
  positions,
  SpaceId,
  occupiedSpaces,
  SpaceOccupation,
  objectNames,
  objectIDs,
  bigWardrobeNames,
  WardrobeSize,
  elementsW15,
  elementsW30,
  elementsW15Top,
  elementsW15Bottom,
  elementsW15Door,
  elementsW30Bottom,
  elementsW30Top,
  elementsW30Doors,
  elementParts,
  hardware,
} from "./constant";
import { create3DCSSElement } from "./utils";
import {
  openLeftDoor,
  openRightDoor,
  closeLeftDoor,
  closeRightDoor,
  openBottomDrawer,
  closeBottomDrawer,
  openMiddleDrawer,
  closeMiddleDrawer,
  openTopDrawer,
  closeTopDrawer,
  openChestBottomDrawer,
  openChestMiddleDrawer,
  openChestTopDrawer,
  closeChestBottomDrawer,
  closeChestMiddleDrawer,
  closeChestTopDrawer,
  openLeftDoorInstant,
  openRightDoorInstant,
  closeLeftDoorInstant,
  closeRightDoorInstant,
  DOOR_OPEN_ANGLE,
  setDoorOpenAngle,
  getDoorOpenAngle,
} from "./AnimationManager.js";

console.log("buildMode", import.meta.env.MODE);

// consts and lets
let heightMes = [];
let depthMes = [];
let Measurements = {
  Width: [],
  Height: [],
  Depth: [],
};
let groupWidthMes = [];
let mesGroupVisibility = true;
let baseUrl = "";
let container; //, stats;
let camera,
  scene,
  renderer,
  controls,
  additionalCamera,
  css2DRenderer,
  css3DRenderer,
  angleCamera,
  angleControls,
  angleCamera2,
  angleControls2;

let lt;
let id;
let updateCam = false;

// const ClosetsGroup = new THREE.Group()

let cameraStartPos = new THREE.Vector3(0, 1.4, 7.5);
let cameraLookAt = new THREE.Vector3(0, 1, 0);

var cabinets = [];

var bigCabinets = [];
var smallCabinets = [];

const buildMode = import.meta.env.MODE;

if (buildMode === "production") {
  baseUrl = "https://modular-verra.s3.amazonaws.com";
}

const loadingManager = new THREE.LoadingManager();

loadingManager.onStart = function (itemUrl, itemsLoaded, itemsTotal) {};
loadingManager.onProgress = function (itemUrl, itemsLoaded, itemsTotal) {};
loadingManager.onLoad = function (itemUrl, itemsLoaded, itemsTotal) {
  onWindowResize();
};

const fontLoader = new FontLoader(loadingManager);
let font;

fontLoader.load(
  baseUrl + "/misc/fonts/favorit_regular.json",
  function (fontLoaded) {
    font = fontLoaded;
  }
);

const frustumSize = 5;

const gui = new GUI({ width: 280 });

document.CabinetVars = {
  SelectedIndex: 0,
};

function getIDFromURL(identification) {
  const urlParams = new URLSearchParams(document.location.search);
  return urlParams.get(identification);
}

id = getIDFromURL("id");

lt = getIDFromURL("lt") || 0.0005;

init(id, lt, true);
animate();
// setTimeout(createCloset, 1000);

var selectionBars = [];

function init(id, thicknessOfLines, cameraMoveInstant = false) {
  container = document.getElementById("mc-canvas");

  const width = container.offsetWidth;
  const height = container.offsetHeight;

  renderer = new THREE.WebGLRenderer({ antialias: true });

  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;

  renderer.setPixelRatio(window.devicePixelRatio * 2);

  renderer.setSize(width, height);

  container.appendChild(renderer.domElement);

  scene = new THREE.Scene();
  const aspect = width / height;

  camera = new THREE.PerspectiveCamera(25, aspect, 0.25, 100);
  camera.position.set(cameraStartPos.x, cameraStartPos.y, cameraStartPos.z);
  camera.lookAt(cameraLookAt.x, cameraLookAt.y, cameraLookAt.z);

  angleCamera = new THREE.PerspectiveCamera(25, aspect, 0.25, 20);
  angleCamera2 = new THREE.PerspectiveCamera(25, aspect, 0.25, 20);
  angleCamera.position.set(
    cameraStartPos.x,
    cameraStartPos.y,
    cameraStartPos.z
  );
  angleCamera2.position.set(
    cameraStartPos.x,
    cameraStartPos.y,
    cameraStartPos.z
  );
  angleCamera.lookAt(cameraLookAt.x, cameraLookAt.y, cameraLookAt.z);
  angleCamera2.lookAt(cameraLookAt.x, cameraLookAt.y, cameraLookAt.z);

  additionalCamera = new THREE.OrthographicCamera(
    (frustumSize * aspect) / -2,
    (frustumSize * aspect) / 2,
    frustumSize / 2,
    frustumSize / -2,
    1,
    1000
  );
  let additionalCameraStartPos = new THREE.Vector3(0, 1.2, 5);
  additionalCamera.position.set(
    additionalCameraStartPos.x,
    additionalCameraStartPos.y,
    additionalCameraStartPos.z
  );

  let previousCabinetLength = 0;
  let cameraResetPos = cameraStartPos;
  let animationsQueue = [];
  let currentAnimation = null;
  let currentZPos = cameraStartPos;
  let targetZPos = new THREE.Vector3(0, 0, 0);
  let gsapcontext = gsap.context(() => {});
  let MoveCamInstant = cameraMoveInstant;
  let cameraInstantTimeoutMs = 500;
  let moveCamTimer;

  function resetMoveCamTimer() {
    clearTimeout(moveCamTimer);
    moveCamTimer = setTimeout(() => {
      MoveCamInstant = false;
    }, cameraInstantTimeoutMs);
  }

  function moveCamera(amountIncreased) {
    if (MoveCamInstant) {
      resetMoveCamTimer();
    }

    updateCam = true;
  }

  function ResetCameraToStart() {
    updateCam = true;
  }
  function resetCameraToStartInstant() {
    gsapcontext.kill();

    cameraStartPos.x = 0;
    camera.position.x = cameraStartPos.x;
    // controls.target.set(camera.position.x, 1, 0);
    additionalCamera.position.set(
      cameraStartPos.x,
      additionalCameraStartPos.y,
      additionalCameraStartPos.z
    );
    targetZPos = 7;

    cameraStartPos.z = 7;

    // camera.position.z = cameraStartPos.z;

    cameraStartPos.x = cameraResetPos.x;
    cameraStartPos.y = cameraResetPos.y;
    cameraStartPos.z = 7;

    additionalCamera.position.set(
      cameraStartPos.x,
      additionalCameraStartPos.y,
      additionalCameraStartPos.z
    );
    angleControls.target.set(camera.position.x, 1, 0);
    angleControls.minDistance = radius;
    angleControls.maxDistance = radius;
    angleControls.update();

    angleControls2.target.set(camera.position.x, 1, 0);
    angleControls2.minDistance = radius;
    angleControls2.maxDistance = radius;
    angleControls2.update();

    cameraLookAt.x = 0;

    camera.lookAt(cameraLookAt.x, cameraLookAt.y, cameraLookAt.z);
  }

  controls = new OrbitControls(camera, renderer.domElement);
  const paramsControls = {
    minDistance: 5,
    maxDistance: 14,
    zoom: 10,
  };

  // controls.minDistance = paramsControls.minDistance;
  // controls.maxDistance = paramsControls.maxDistance;
  controls.target.set(0, 1, 0);
  controls.update();
  controls.enabled = true;
  controls.enablePan = false;
  controls.enableDamping = true;
  controls.dampingFactor = 0.05;
  controls.minPolarAngle = 0;
  controls.maxPolarAngle = Math.PI / 2;

  controls.minAzimuthAngle = -Math.PI * (45 / 180);
  controls.maxAzimuthAngle = Math.PI * (45 / 180);
  //
  angleControls = new OrbitControls(angleCamera, renderer.domElement);
  angleControls.target.set(0, 1, 0);
  angleControls2 = new OrbitControls(angleCamera2, renderer.domElement);
  angleControls2.target.set(0, 1, 0);

  angleControls.enabled = false;
  angleControls2.enabled = false;

  var radius = 7;
  angleControls.minDistance = 7;
  angleControls.maxDistance = 7;
  angleControls2.minDistance = 7;
  angleControls2.maxDistance = 7;

  var theta = THREE.MathUtils.degToRad(115);

  // Calculate the initial position
  var x = radius * Math.cos(theta);
  var z = radius * Math.sin(theta);

  angleCamera.position.set(x, 1, z);
  angleControls.update();
  angleCamera2.position.set(x, 1, z);
  angleControls2.update();
  //
  const controlsFolder = gui.addFolder("Zoom Controls");
  controlsFolder.close();
  const orbitControlsFolder = gui.addFolder("Orbit Controls");
  const cameraInstantFolder = gui.addFolder("Camera Instant");
  cameraInstantFolder.close();
  const minDistanceController = controlsFolder
    .add(paramsControls, "minDistance", 1, 25)
    .name("Min Distance");
  const maxDistanceController = controlsFolder
    .add(paramsControls, "maxDistance", 1, 25)
    .name("Max Distance");
  const zoomController = controlsFolder
    .add(
      paramsControls,
      "zoom",
      paramsControls.minDistance,
      paramsControls.maxDistance
    )
    .name("Zoom");

  const instantParams = {
    instant: MoveCamInstant,
    timeoutMs: cameraInstantTimeoutMs,
  };

  cameraInstantFolder
    .add(instantParams, "instant")
    .name("Instant Move")
    .onChange(function (value) {
      MoveCamInstant = !!value;
      if (!MoveCamInstant) {
        clearTimeout(moveCamTimer);
      } else {
        // keep current timeout behavior
        resetMoveCamTimer();
      }
    });

  cameraInstantFolder
    .add(instantParams, "timeoutMs", 0, 5000, 50)
    .name("Instant Timeout (ms)")
    .onChange(function (value) {
      const n = Number(value);
      if (!Number.isNaN(n) && n >= 0) {
        cameraInstantTimeoutMs = n;
      }
    });

  minDistanceController.onChange(function (value) {
    controls.minDistance = value;
  });

  maxDistanceController.onChange(function (value) {
    controls.maxDistance = value;
  });
  let prevMinDistance, prevMaxDistance;
  zoomController.onChange(function (value) {
    if (prevMinDistance === undefined && prevMaxDistance === undefined) {
      prevMinDistance = controls.minDistance;
      prevMaxDistance = controls.maxDistance;
    }

    controls.minDistance = value;
    // controls.maxDistance = value;
    controls.update();
  });
  zoomController.onFinishChange(function () {
    // Reset minDistance and maxDistance to previous values
    if (prevMinDistance !== undefined && prevMaxDistance !== undefined) {
      controls.minDistance = prevMinDistance;
      controls.maxDistance = prevMaxDistance;
      controls.update();

      // Reset previous values
      prevMinDistance = undefined;
      prevMaxDistance = undefined;
    }
  });

  const light = new THREE.DirectionalLight(0xddffdd, 0.1);
  light.position.set(3, 4, 3);
  light.castShadow = false;

  light.shadow.mapSize.width = 1024;
  light.shadow.mapSize.height = 1024;
  light.shadow.camera.near = 0.5;
  light.shadow.camera.far = 1000;

  scene.add(light);

  const textureLoader = new THREE.TextureLoader(loadingManager);
  //Comment this to remove radial shadows
  ////////////////////start
  let Splatter_Texture;
  let Radial_Texture;
  let ReflectionTexture;

  let splatterMaterial = new THREE.MeshBasicMaterial();
  let radialMaterial = new THREE.MeshBasicMaterial();
  var fakeReflectionMaterial = new THREE.MeshBasicMaterial();

  textureLoader.load(baseUrl + "/textures/Reflection.png", function (texture) {
    ReflectionTexture = texture;
    //ReflectionTexture.flipY = false;
    fakeReflectionMaterial.map = ReflectionTexture;
    fakeReflectionMaterial.needsUpdate = true;
  });

  textureLoader.load(
    baseUrl + "/textures/RoundSplatter.png",
    function (texture) {
      Splatter_Texture = texture;
      Splatter_Texture.flipY = false;

      splatterMaterial.map = Splatter_Texture;
      splatterMaterial.transparent = true;
      splatterMaterial.alphaMap = texture;
      splatterMaterial.side = THREE.DoubleSide;
      splatterMaterial.opacity = 3;
    }
  );
  textureLoader.load(
    baseUrl + "/textures/RoundGradial.png",
    function (texture) {
      Radial_Texture = texture;
      Radial_Texture.flipY = false;

      radialMaterial.map = Radial_Texture;
      radialMaterial.transparent = true;
      radialMaterial.alphaMap = texture;
      radialMaterial.side = THREE.DoubleSide;
      radialMaterial.opacity = 10;
    }
  );
  ///////////////end

  const planeGeometry2 = new THREE.PlaneGeometry(10, 10);
  const planeMaterial2 = new THREE.ShadowMaterial({ opacity: 0.5 });
  const shadowPlane = new THREE.Mesh(planeGeometry2, planeMaterial2);
  //const shadowPlane = new THREE.Mesh(planeGeometry2, radialMaterial);
  //const shadowPlane = new THREE.Mesh(planeGeometry2, splatterMaterial);
  shadowPlane.rotation.x = -Math.PI / 2;
  shadowPlane.position.y = -0.01;
  shadowPlane.receiveShadow = true;
  shadowPlane.name = "shadow Plane";

  scene.add(shadowPlane);

  var wallgeometry = new THREE.PlaneGeometry(25, 10, 32);
  var Wallmaterial = new THREE.MeshBasicMaterial();
  Wallmaterial.color.set(0xfbf9f8);
  Wallmaterial.receiveShadow = true;
  var Wall = new THREE.Mesh(wallgeometry, Wallmaterial);
  var WallShadow = new THREE.ShadowMaterial({ opacity: 0.5 });
  var WallShadowMesh = new THREE.Mesh(wallgeometry, WallShadow);
  WallShadowMesh.receiveShadow = true;

  WallShadowMesh.position.set(0, 5, -0.349);
  Wall.receiveShadow = true;
  Wall.position.set(0, 5, -0.35);

  WallShadowMesh.name = "Wall shadow";
  Wall.name = "Wall";

  scene.add(WallShadowMesh);
  scene.add(Wall);

  //Comment this to remove radial shadows
  ////////////////////start
  const planeGeometry3 = new THREE.PlaneGeometry(2.2, 2.2);

  const radialShadowPlane = new THREE.Mesh(planeGeometry3, radialMaterial);
  radialShadowPlane.rotation.x = -Math.PI / 2;
  radialShadowPlane.position.y = -0.0065;
  radialShadowPlane.name = "Shadow plane";

  renderer.domElement.style.touchAction = "none";

  const material = new THREE.MeshStandardMaterial({
    color: 0xebeae4,
    roughness: 0.837,
    metalness: 0,
    flatShading: true,
  });
  const materialNoAO = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    roughness: 0.8,
    metalness: 0.25,
    flatShading: true,
  });

  const sceneOptions = { backgroundColor: 0xfbf9f8 };

  let isDarkBackground = false;
  function toggleColor() {
    if (isDarkBackground) {
      scene.background = new THREE.Color(0xffffff);
    } else {
      scene.background = new THREE.Color(0xf5deb3); //F5DEB3  //F5F5DC
    }
    isDarkBackground = !isDarkBackground;
  }

  const toggleButton = { toggleColor: toggleColor };
  gui.add(toggleButton, "toggleColor").name("Toggle Background");

  let EnvTex;

  new RGBELoader()
    .setPath(baseUrl + "/textures/")
    .load("brown_photostudio_02_2k.hdr", function (texture) {
      texture.mapping = THREE.EquirectangularReflectionMapping;
      EnvTex = texture;
      scene.background = new THREE.Color(sceneOptions.backgroundColor); //new THREE.Color(0xffffff);
      material.envMap = EnvTex;
      material.envMapIntensity = 0.5;
      // material.aoMap = AO_Texture;
      material.aoMapIntensity = 0.8;
      material.needsUpdate = true;

      materialNoAO.envMap = EnvTex;
      materialNoAO.envMapIntensity = 0.5;
      materialNoAO.needsUpdate = true;

      mirrorMaterial.envMap = EnvTex;
      mirrorMaterial.envMapIntensity = 1;
      mirrorMaterial.needsUpdate = true;

      chromeMaterial.envMap = EnvTex;
      chromeMaterial.envMapIntensity = 0.9;
      chromeMaterial.needsUpdate = true;

      chromeMaterialBrushed.envMap = EnvTex;
      chromeMaterialBrushed.envMapIntensity = 0.9;
      chromeMaterialBrushed.needsUpdate = true;

      // Apply environment map to rod materials
      rodMaterialBlack.envMap = EnvTex;
      rodMaterialBlack.envMapIntensity = 0.9;
      rodMaterialBlack.needsUpdate = true;

      rodMaterialBrass.envMap = EnvTex;
      rodMaterialBrass.envMapIntensity = 0.9;
      rodMaterialBrass.needsUpdate = true;

      rodMaterialChrome.envMap = EnvTex;
      rodMaterialChrome.envMapIntensity = 0.9;
      rodMaterialChrome.needsUpdate = true;

      rodMaterialNickel.envMap = EnvTex;
      rodMaterialNickel.envMapIntensity = 0.9;
      rodMaterialNickel.needsUpdate = true;

      // Update all already-loaded rod objects with environment map
      // This ensures rods loaded before EnvTex was ready get the environment map
      Object.keys(objects).forEach((objName) => {
        if (objName.toLowerCase().includes("_rod")) {
          const rodObj = objects[objName];
          if (rodObj) {
            rodObj.traverse((child) => {
              if (child.isMesh && child.material) {
                // Check if this is a rod material (has high metalness)
                if (child.material.metalness > 0.7) {
                  child.material.envMap = EnvTex;
                  child.material.envMapIntensity = 0.9;
                  child.material.needsUpdate = true;
                }
              }
            });
          }
        }
      });
    });
  //var textureLoader = new THREE.TextureLoader();
  let AO_Texture;

  textureLoader.load(baseUrl + "/textures/AO_Texture.png", function (texture) {
    AO_Texture = texture;
    AO_Texture.flipY = false;
  });

  // textureLoader.load("/textures/AO_Texture.png", function (texture) {
  // 	AO_Texture = texture;
  // 	AO_Texture.flipY = false;
  // });
  let arrow_Texture;
  const arrowMaterial = new THREE.MeshBasicMaterial({});
  arrowMaterial.color.set(0x2b87c9);

  //Edited BaseURL - new Texture
  textureLoader.load(baseUrl + "/textures/arrowhead.png", function (texture) {
    arrow_Texture = texture;
    arrow_Texture.flipY = false;
    arrowMaterial.map = arrow_Texture;
    arrowMaterial.alphaTest = 0.85;
  });

  var objects = {};

  // Positions to which object need to snap when close

  function calculateItemQuantities(objectsList, objectIDs) {
    var itemsInfo = {};

    // Counting occurrences of each object
    objectsList.forEach(function (item) {
      var id = objectIDs[item]; // Fetching ID from objectIDs
      if (id) {
        itemsInfo[id] = (itemsInfo[id] || 0) + 1;
      }
    });

    return itemsInfo;
  }

  // const calcFolder = gui.addFolder("Calculate Quantities Button");
  // calcFolder
  //   .add(
  //     {
  //       calculateQuantities: function () {
  //         var quantities = calculateItemQuantities(ListOfObjects, objectIDs);
  //       },
  //     },
  //     "calculateQuantities"
  //   )
  //   .name("Calculate Quantities");

  var cabinet = new THREE.Object3D();
  cabinet.insidePositionsW30 = positions;
  cabinet.insideOccupiedSpaces = occupiedSpaces;

  cabinet.slots = {
    chestOfDrawers: null,
    leftDoor: null,
    rightDoor: null,
    bottomDrawer: null,
    middleDrawer: null,
    topDrawer: null,
  };
  const SlotMappings = {
    leftDoor: [
      "One_Mirror_Door_Left",
      "One_Flat_Door_Left",
      "One_Shaker_Door_Left",
      "One_Mirror_Door_Left_W15",
      "One_Flat_Door_Left_W15",
      "One_Shaker_Door_Left_W15",
    ],
    rightDoor: [
      "One_Mirror_Door_Right",
      "One_Flat_Door_Right",
      "One_Shaker_Door_Right",
      "One_Mirror_Door_W15",
      "One_Flat_Door_W15",
      "One_Shaker_Door_W15",
    ],
    chestOfDrawers: [
      "Chest_of_Drawers_Separate",
      "Chest_of_Drawers_Separate_W15",
    ],
  };

  const SelectionFolder = gui.addFolder("Select Cabinet");
  SelectionFolder.add(
    document.CabinetVars,
    "SelectedIndex",
    0,
    cabinet.length
  ).onChange(function (value) {
    document.CabinetVars.SelectedIndex = Number(value);
  });

  function deepCloneCabinet(originalObject) {
    var clonedObject = originalObject.clone();

    // Copy the properties
    clonedObject.insidePositionsW30 = deepClonePositions(
      originalObject.insidePositionsW30
    );
    clonedObject.insideOccupiedSpaces = deepCloneOccupiedSpaces(
      originalObject.insideOccupiedSpaces
    );

    clonedObject.slots = {
      chestOfDrawers: null,
      leftDoor: null,
      rightDoor: null,
      bottomDrawer: null,
      middleDrawer: null,
      topDrawer: null,
    };
    if (originalObject.part) {
      clonedObject.part = towerWithPart[originalObject.name]
        ? JSON.parse(JSON.stringify(towerWithPart[originalObject.name]))
        : {};
    }
    return clonedObject;
  }
  function deepClonePositions(originalPositions) {
    var clonedPositions = {};

    for (const key in originalPositions) {
      if (originalPositions.hasOwnProperty(key)) {
        const vectors = originalPositions[key];
        clonedPositions[key] = vectors.map(
          (vector) => new THREE.Vector3(vector.x, vector.y, vector.z)
        );
      }
    }

    return clonedPositions;
  }

  function deepCloneOccupiedSpaces(originalOccupiedSpaces) {
    var clonedOccupiedSpaces = {};

    for (const key in originalOccupiedSpaces) {
      if (originalOccupiedSpaces.hasOwnProperty(key)) {
        // Ensure a new array is created for each key
        clonedOccupiedSpaces[key] = originalOccupiedSpaces[key].slice();
      }
    }

    return clonedOccupiedSpaces;
  }

  function AdjustCabinetPosition(clonedCabinet, amount) {
    for (const key in clonedCabinet.insidePositionsW30) {
      if (clonedCabinet.insidePositionsW30.hasOwnProperty(key)) {
        const vectors = clonedCabinet.insidePositionsW30[key];
        for (let i = 0; i < vectors.length; i++) {
          vectors[i].x += amount;
        }
      }
    }
  }

  let SelectionBar;

  function AddSelectionBar(position, ifSmall) {
    create3DCSSElement(
      position.x,
      2.3,
      0.25,
      0,
      ifSmall,
      cabinets,
      selectionBars,
      scene
    );
  }

  function removeLastSelectionBar() {
    if (selectionBars.length > 0) {
      const lastSelectionBar = selectionBars.pop();
      scene.remove(lastSelectionBar);
    }
  }

  css2DRenderer = new CSS2DRenderer();
  css2DRenderer.setSize(width, height);
  css2DRenderer.domElement.style.position = "absolute";
  css2DRenderer.domElement.style.top = "0px";
  css2DRenderer.domElement.style.pointerEvents = "none";
  document.body.appendChild(css2DRenderer.domElement);

  function addBigSnapPositions(indexOfPositions) {
    elementsW30.forEach((modelName) => {
      const snapPositions = positions[modelName];

      const modelObject = objects[modelName];

      if (modelObject) {
        modelObject.snapPosition.push(snapPositions);
      }
    });

    elementsW15.forEach((modelName) => {
      const emptyArray = [];
      const modelObject = objects[modelName];

      if (modelObject) {
        modelObject.snapPosition.push(emptyArray);
      }
    });
  }

  function removeLastBigSnapPositions() {
    elementsW30.forEach((modelName) => {
      const modelObject = objects[modelName];
      if (modelObject && modelObject.snapPosition.length > 0) {
        modelObject.snapPosition.pop();
      }
    });

    elementsW15.forEach((modelName) => {
      const modelObject = objects[modelName];
      if (modelObject && modelObject.snapPosition.length > 0) {
        modelObject.snapPosition.pop();
      }
    });
  }

  function removeLastSmallSnapPositions() {
    elementsW15.forEach((modelName) => {
      const modelObject = objects[modelName];
      if (modelObject && modelObject.snapPosition.length > 0) {
        modelObject.snapPosition.pop();
      }
    });

    elementsW30.forEach((modelName) => {
      const modelObject = objects[modelName];
      if (modelObject && modelObject.snapPosition.length > 0) {
        modelObject.snapPosition.pop();
      }
    });
  }

  //This can be removed after materials are correctly setup with HDRI
  const ambientLight = new THREE.AmbientLight(0x404040, 3);
  scene.add(ambientLight);
  let medianXPoint = 0;
  let isLastCabinetBig = false;
  let CabinetSizesArray = [];
  let lastAddedValue;
  let lastPosition = 0;
  document.cabinetsInScene = [];
  let lastAdditionalCabinet;
  // function addBigAdditionalCabinetFilled() {
  //   addBigAdditionalCabinet(0.782);
  // }
  function addBigAdditionalCabinet(positionAdjValue, name) {
    console.log(
      `[DEBUG] addBigAdditionalCabinet - Adding cabinet: ${name}, positionAdjValue: ${positionAdjValue}`
    );
    const cabinet = objects[name];
    var newCabinet = deepCloneCabinet(cabinet);

    let amountToIncrease = positionAdjValue * cabinets.length;

    if (!isLastCabinetBig) {
      medianXPoint += positionAdjValue - positionAdjValue / 4;
      lastAddedValue = positionAdjValue - positionAdjValue / 4;
    } else {
      medianXPoint += positionAdjValue;
      lastAddedValue = positionAdjValue;
    }

    // AdjustCabinetPosition(newCabinet, medianXPoint);

    // elementsW30.forEach((modelName) => {
    //   const modelObject = objects[modelName];
    //   if (modelObject) {
    //     modelObject.snapPosition.push(newCabinet.insidePositionsW30[modelName]);
    //     //createBoxesForModel(modelObject, modelObject.model, cabinets.length);
    //   }
    // });

    // elementsW15.forEach((modelName) => {
    //   const modelObject = objects[modelName];
    //   const emptyArray = [];
    //   if (modelObject) {
    //     modelObject.snapPosition.push(emptyArray);
    //     //modelObject.boxes.push(emptyArray);
    //   }
    // });

    let object = deepCloneObject(objects[name]);
    object.NameOfObject = name;
    object.position.copy(new THREE.Vector3(medianXPoint, 0, 0));
    scene.add(object);

    //createArrowsHeight(scene,object, 1.2, 0);

    lastAdditionalCabinet = object;

    moveCamera(medianXPoint / 2);

    cabinets.push(newCabinet);
    bigCabinets.push(newCabinet);

    removeGroupedMes();

    createArrowsWidth(scene, object, 0.45, object.name, font);

    if (object.NameOfObject) ListOfObjects.push(object.NameOfObject);
    ObjectsInScene.push(object);
    document.cabinetsInScene.push(object);

    AddSelectionBar(new THREE.Vector3(medianXPoint, 0, 0), false);

    isLastCabinetBig = true;
    let isItBig = isLastCabinetBig;
    CabinetSizesArray.push(isItBig);
  }

  function removeLastCabinet() {
    if (isLastCabinetBig) {
      medianXPoint -= lastAddedValue;

      CabinetSizesArray.pop();
      isLastCabinetBig = CabinetSizesArray[CabinetSizesArray.length - 1];

      removeLastBigSnapPositions();
      removeLastSelectionBar();
      cabinets.pop();
      bigCabinets.pop();
      scene.remove(lastAdditionalCabinet);
      removeLastMeasurement();

      // Remove the actual width of the last cabinet
      const lastWidth = cabinetWidths.pop();
      console.log(
        `[DEBUG] Removing big cabinet, width: ${lastWidth}", current total: ${
          groupWidth.width
        }, new total: ${groupWidth.width - lastWidth}`
      );
      groupWidth.width = groupWidth.width - lastWidth;
      console.log(
        `[DEBUG] Cabinet widths array after removal: [${cabinetWidths.join(
          ", "
        )}]`
      );

      ListOfObjects.pop();
      ObjectsInScene.pop();
      document.cabinetsInScene.pop();
      updateGroupedWidthArrows(document.cabinetsInScene);
      //OVDJE
    } else {
      medianXPoint -= lastAddedValue;

      CabinetSizesArray.pop();
      isLastCabinetBig = CabinetSizesArray[CabinetSizesArray.length - 1];

      removeLastSmallSnapPositions();
      removeLastSelectionBar();
      cabinets.pop();
      smallCabinets.pop();
      scene.remove(lastAdditionalCabinet);

      removeLastMeasurement();
      // Remove the actual width of the last cabinet
      const lastWidth = cabinetWidths.pop();
      console.log(
        `[DEBUG] Removing small cabinet, width: ${lastWidth}", current total: ${
          groupWidth.width
        }, new total: ${groupWidth.width - lastWidth}`
      );
      groupWidth.width = groupWidth.width - lastWidth;
      console.log(
        `[DEBUG] Cabinet widths array after removal: [${cabinetWidths.join(
          ", "
        )}]`
      );
      ///
      ListOfObjects.pop();
      ObjectsInScene.pop();
      document.cabinetsInScene.pop();
      updateGroupedWidthArrows(document.cabinetsInScene);
    }
  }
  const removeLastCabinetButtonFolder = gui.addFolder("Remove Last Cabinet");
  removeLastCabinetButtonFolder.close();

  removeLastCabinetButtonFolder
    .add({ add: () => removeLastCabinet() }, "add")
    .name("Remove Last Cabinet");

  function swapLastSmallCabinet(positionAdjValue) {
    medianXPoint -= lastAddedValue;

    var isBig = CabinetSizesArray.pop();
    isLastCabinetBig = CabinetSizesArray[CabinetSizesArray.length - 1];

    removeLastSmallSnapPositions();
    removeLastSelectionBar();
    cabinets.pop();
    smallCabinets.pop();
    scene.remove(lastAdditionalCabinet);

    removeLastMeasurement();
    // Remove the actual width of the last cabinet
    const lastWidth = cabinetWidths.pop();
    console.log(
      `[DEBUG] Swapping cabinet, removing width: ${lastWidth}", current total: ${
        groupWidth.width
      }, new total: ${groupWidth.width - lastWidth}`
    );
    groupWidth.width = groupWidth.width - lastWidth;
    console.log(
      `[DEBUG] Cabinet widths array after swap removal: [${cabinetWidths.join(
        ", "
      )}]`
    );
    ///
    ListOfObjects.pop();
    ObjectsInScene.pop();
    document.cabinetsInScene.pop();
    addBigAdditionalCabinet(positionAdjValue);
  }

  function addAdditionalCabinet(name) {
    const object = WardrobeSize.find((o) => o.name === name);
    const lastCabitnetName =
      document.cabinetsInScene[document.cabinetsInScene.length - 1].name;
    const lastCabitnet = WardrobeSize.find((o) => o.name === lastCabitnetName);
    addBigAdditionalCabinet(
      object.halfWidth + lastCabitnet.halfWidth - 0.01867,
      object.name
    );
    renderer.render(scene, camera);
  }

  const addCabinetButtonFolder = gui.addFolder("Add Additional Cabinet ");
  addCabinetButtonFolder.close();

  for (const name of bigWardrobeNames) {
    addCabinetButtonFolder
      .add(
        {
          add: () => {
            // debugger;
            const object = WardrobeSize.find((o) => o.name === name);
            const lastCabitnetName =
              document.cabinetsInScene[document.cabinetsInScene.length - 1]
                .name;
            const lastCabitnet = WardrobeSize.find(
              (o) => o.name === lastCabitnetName
            );
            // debugger;
            addBigAdditionalCabinet(
              object.halfWidth + lastCabitnet.halfWidth - 0.01867,
              object.name
            );
          },
        },
        "add"
      )
      .name(`Add Cabinet ${name}`);
  }

  // const swapCabinetButtonFolder = gui.addFolder("Swap Last Cabinet Size");
  // swapCabinetButtonFolder.close();

  // swapCabinetButtonFolder
  //   .add({ add: () => swapLastSmallCabinet(0.782) }, "add")
  //   .name("Swap Cabinet to W30");

  const loader = new GLTFLoader(loadingManager);

  loader.load(baseUrl + "/misc/SelectionBar.glb", function (gltf) {
    SelectionBar = gltf.scene;
    var Smaterial = new THREE.MeshBasicMaterial({
      color: 0x000000,
    });

    SelectionBar.traverse(function (child) {
      if (child.isMesh) {
        child.material = Smaterial;
      }
    });

    SelectionBar.visible = false;
  });

  var mirrorMaterial = new THREE.MeshStandardMaterial({
    color: 0xffffff, //update to closet color
    //color: 0x000000,
    metalness: 0.9,
    roughness: 0.1,
  });
  var chromeMaterial = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    metalness: 1,
    roughness: 0,
  });
  var chromeMaterialBrushed = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    metalness: 0.95,
    roughness: 0.2,
  });

  // Rod color materials - rods use the same model with different materials
  var rodMaterialBlack = new THREE.MeshStandardMaterial({
    color: 0x1a1a1a,
    metalness: 0.8,
    roughness: 0.3,
  });
  var rodMaterialBrass = new THREE.MeshStandardMaterial({
    color: 0xb8860b,
    metalness: 0.9,
    roughness: 0.2,
  });
  var rodMaterialChrome = new THREE.MeshStandardMaterial({
    color: 0xffffff,
    metalness: 1,
    roughness: 0,
  });
  var rodMaterialNickel = new THREE.MeshStandardMaterial({
    color: 0xc0c0c0,
    metalness: 0.95,
    roughness: 0.1,
  });

  // Helper function to get rod material based on color suffix
  function getRodMaterial(color) {
    switch (color.toUpperCase()) {
      case "BLACK":
        return rodMaterialBlack;
      case "BRASS":
        return rodMaterialBrass;
      case "CHROME":
        return rodMaterialChrome;
      case "NICKEL":
        return rodMaterialNickel;
      default:
        return rodMaterialChrome; // Default to chrome
    }
  }

  // Helper function to extract base rod name from color variant
  function getBaseRodName(rodName) {
    // Remove color suffix (e.g., "33/33W_ROD_BRASS" -> "33/33W_ROD")
    return rodName.replace(/_ROD_(BLACK|BRASS|CHROME|NICKEL).*/, "_ROD");
  }

  // Helper function to extract color from rod name
  function getRodColor(rodName) {
    const match = rodName.match(/_ROD_(BLACK|BRASS|CHROME|NICKEL)/);
    return match ? match[1] : null; // Return null if no color in name
  }

  // Global hardware color state - default to CHROME
  if (!document.globalHardwareColor) {
    document.globalHardwareColor = "CHROME";
  }

  function loadModel(modelName, filePath) {
    return new Promise((resolve, reject) => {
      loader.load(
        filePath,
        (gltf) => {
          const model = gltf.scene;
          //const edgesMaterial = new THREE.LineBasicMaterial({ color: 0x000000, linewidth: 5 });
          var modelObject = new THREE.Object3D();
          let matLine = new LineMaterial({
            color: 0x000000,
            linewidth: thicknessOfLines,
          });

          let wireframes = [];
          // Check if this is a rod with a color variant
          const isRodColorVariant = modelName.match(
            /_ROD_(BLACK|BRASS|CHROME|NICKEL)/
          );
          const rodColor = isRodColorVariant ? getRodColor(modelName) : null;

          model.traverse((child) => {
            if (child.isMesh) {
              child.castShadow = true;
              child.receiveShadow = true;
              if (
                modelName.toLowerCase().includes("pull_modern") ||
                modelName.toLowerCase().includes("pull_knob")
              ) {
                const color = child.material.color.clone();
                const map = child.material.map.clone();
                child.material = material.clone();
                child.material.color = color;
                child.material.map = map;
                child.material.needsUpdate = true;
              } else if (modelName.toLowerCase().includes("rod")) {
                // Apply rod material - use color from name if specified, otherwise use global color
                // Always use a rod material, never the default material
                const colorToUse =
                  rodColor || document.globalHardwareColor || "CHROME";
                const rodMat = getRodMaterial(colorToUse);
                const clonedMat = rodMat.clone();
                // Ensure environment map is applied if available
                if (typeof EnvTex !== "undefined" && EnvTex) {
                  clonedMat.envMap = EnvTex;
                  clonedMat.envMapIntensity = 0.9;
                }
                child.material = clonedMat;
                child.material.needsUpdate = true;
              } else {
                child.material = material;
              }
              // child.material = material;

              const clone = child.geometry.clone();
              child.updateMatrix();
              child.updateWorldMatrix(true, true);
              clone.applyMatrix4(child.matrixWorld);
              var edgesGeometry = new THREE.EdgesGeometry(clone);

              var lineGeometry = new LineSegmentsGeometry().fromEdgesGeometry(
                edgesGeometry
              );

              let wireframe = new Wireframe(lineGeometry, matLine);
              wireframe.userData.isFrame = true;
              wireframe.computeLineDistances();
              wireframe.scale.set(1.001, 1.001, 1.001);
              wireframes.push(wireframe);
              if (
                modelName.toLowerCase().includes("_fdo") ||
                modelName.toLowerCase().includes("_3qd") ||
                modelName.toLowerCase().includes("_hdo") ||
                modelName.toLowerCase().includes("_fhd")
              ) {
                // wireframe.position.z = wireframe.position.z + 0.1;
              }
              // if (modelName.toLowerCase().includes("_ss")) {
              //   child.updateMatrixWorld(true);
              //   // wireframe.position.set(0, -0.5, 0);
              //   scene.add(wireframe.clone(true));
              //   // scene.add(child.clone(true));
              // }

              // if (
              //   child.name === "Wardrobe_NoDivider_D22_W15" ||
              //   child.name === "Wardrobe_NoDivider_D22_W30"
              // ) {
              //   child.material = material;
              // } else {
              //   child.material = materialNoAO;
              // }
              // child.material = materialNoAO;

              // if (child.name === "Cube191" || child.name === "Cube045") {
              //   child.material = mirrorMaterial;
              // }
              // if (child.name === "Cube191_1" || child.name === "Cube045_1") {
              //   child.material = materialNoAO;
              // }
              // if (modelName.toLowerCase().includes("_rod")) {
              //   child.material = chromeMaterial;
              // }
              // if (
              //   child.name === "DoorHandle_Left" ||
              //   child.name === "DoorHandle_Right"
              // ) {
              //   child.material = chromeMaterial;
              // }
              // if (
              //   child.name === "Door_Handle_L" ||
              //   child.name === "Door_Handle_R"
              // ) {
              //   child.material = chromeMaterial;
              // }
            }
          });
          if (
            modelName.toLowerCase().includes("_fdo") ||
            modelName.toLowerCase().includes("_3qd") ||
            modelName.toLowerCase().includes("_hdo") ||
            modelName.toLowerCase().includes("_fhd") ||
            modelName.toLowerCase().includes("_hdp")
          ) {
            // debugger;
            const position = new THREE.Vector3();
            const quaternion = new THREE.Quaternion();
            const scale = new THREE.Vector3();
            const min = new THREE.Vector3();
            let door;
            model.traverse((child) => {
              if (child.isMesh) {
                child.userData.isDoor = true;
                // const geometry = child.geometry;
                // child.updateWorldMatrix(true, true);
                // child.matrixWorld.decompose(position, quaternion, scale);
                // // geometry.applyMatrix4(child.matrixWorld);
                // child.position.set(0, 0, 0);
                // child.rotation.set(0, 0, 0);
                // child.scale.set(1, 1, 1);
                // child.geometry.computeBoundingBox();
                // const bbox = child.geometry.boundingBox;
                // min.copy(bbox.min);
              }
            });
            // modelObject.position.copy(position);
            // modelObject.rotation.set(0, Math.PI / 2, 0);
            // modelObject.scale.copy(scale);
          }
          modelObject.add(model);
          wireframes.forEach((wireframe) => {
            if (
              modelName.toLowerCase().includes("_fdo") ||
              modelName.toLowerCase().includes("_3qd") ||
              modelName.toLowerCase().includes("_hdo") ||
              modelName.toLowerCase().includes("_fhd") ||
              modelName.toLowerCase().includes("_hdp")
            ) {
              model.children[0].attach(wireframe);
            } else {
              modelObject.add(wireframe);
            }
          });

          if (modelName.toLowerCase().includes("tower")) {
            const box = new THREE.Box3().setFromObject(model);
            const halfWidth = (box.max.x - box.min.x) / 2;
            const halfHeight = (box.max.y - box.min.y) / 2;
            const wardrobe = WardrobeSize.find((o) => o.name === modelName);
            if (wardrobe) {
              wardrobe.halfWidth = halfWidth;
              wardrobe.halfHeight = halfHeight;
            }
            // modelObject.traverse((child) => {
            //   if (child.isMesh) {
            //     child.geometry.translate(0, halfHeight, 0);
            //   }
            // });
          }
          modelObject.model = model;
          modelObject.snapPosition = [];
          modelObject.spaceId = SpaceOccupation[modelName];
          modelObject.spaceIndex = 0;
          modelObject.cabinetIndex = 0;
          modelObject.snapped = false;
          modelObject.name = modelName;
          modelObject.part = towerWithPart[modelName]
            ? JSON.parse(JSON.stringify(towerWithPart[modelName]))
            : {};

          objects[modelName] = modelObject;

          // Resolve the Promise when the model is successfully loaded
          resolve();
        },
        undefined,
        (error) => {
          reject(error);
        }
      );
    });
  }
  console.log(WardrobeSize);

  //Load Promises
  const loadModelPromises = objectNames.map((modelName) => {
    //EDITED Base URL - edited models
    const filePath = baseUrl + "/new_models/" + modelName + ".glb";
    return loadModel(modelName, filePath);
  });

  const duplicate = {};
  const towerWithPart = {};
  // debugger;
  for (const modelName of Object.keys(elementParts)) {
    if (!towerWithPart[modelName]) {
      towerWithPart[modelName] = {};
    }
    // Initialize main parts
    towerWithPart[modelName]["top"] = {};
    towerWithPart[modelName]["bottom"] = {};
    towerWithPart[modelName]["door"] = {};
    towerWithPart[modelName]["drawerHardware"] = {};
    towerWithPart[modelName]["doorHardware"] = {};

    // Top parts
    for (const part of elementParts[modelName].top) {
      if (!part.includes("Extra")) {
        // Check if this is a rod color variant (e.g., "33/33W_ROD_BRASS")
        const isRodColorVariant = part.match(
          /_ROD_(BLACK|BRASS|CHROME|NICKEL)/
        );
        let filePath;
        let loadName = part;

        if (isRodColorVariant) {
          // Load the base rod model instead of the color variant
          const baseRodName = getBaseRodName(part);
          filePath = baseUrl + "/new_models/" + baseRodName + ".glb";
          // But register it with the color variant name so it can be found later
          loadName = part;
        } else {
          filePath = baseUrl + "/new_models/" + part + ".glb";
        }

        // For rod color variants, we need to load each color variant separately
        // even though they use the same base file, because they have different materials
        const duplicateKey = isRodColorVariant ? part : filePath;
        if (!duplicate[duplicateKey]) {
          loadModelPromises.push(loadModel(loadName, filePath));
          duplicate[duplicateKey] = true;
        }
      }
      towerWithPart[modelName]["top"][part] = null;
    }

    // Bottom parts
    for (const part of elementParts[modelName].bottom) {
      if (!part.includes("Extra")) {
        // Check if this is a rod color variant (e.g., "33/33W_ROD_BRASS")
        const isRodColorVariant = part.match(
          /_ROD_(BLACK|BRASS|CHROME|NICKEL)/
        );
        let filePath;
        let loadName = part;

        if (isRodColorVariant) {
          // Load the base rod model instead of the color variant
          const baseRodName = getBaseRodName(part);
          filePath = baseUrl + "/new_models/" + baseRodName + ".glb";
          // But register it with the color variant name so it can be found later
          loadName = part;
        } else {
          filePath = baseUrl + "/new_models/" + part + ".glb";
        }

        // For rod color variants, we need to load each color variant separately
        // even though they use the same base file, because they have different materials
        const duplicateKey = isRodColorVariant ? part : filePath;
        if (!duplicate[duplicateKey]) {
          loadModelPromises.push(loadModel(loadName, filePath));
          duplicate[duplicateKey] = true;
        }
      }
      towerWithPart[modelName]["bottom"][part] = null;
    }

    // Door parts
    for (const part of elementParts[modelName].door) {
      if (!part.includes("Extra")) {
        const filePath = baseUrl + "/new_models/" + part + ".glb";
        if (!duplicate[filePath]) {
          loadModelPromises.push(loadModel(part, filePath));
        } else {
          duplicate[filePath] = true;
        }
      }
      towerWithPart[modelName]["door"][part] = null;
    }

    // Drawer Hardware - pulls and knobs
    for (const part of hardware.drawer.pull) {
      if (!part.includes("Extra")) {
        const filePath = baseUrl + "/new_models/pull/" + part + ".glb";
        if (!duplicate[filePath]) {
          loadModelPromises.push(loadModel(part, filePath));
          duplicate[filePath] = true;
        }
      }
      towerWithPart[modelName]["drawerHardware"][part] = null;
    }
    for (const part of hardware.door.pull) {
      if (!part.includes("Extra")) {
        const filePath = baseUrl + "/new_models/pull/" + part + ".glb";
        if (!duplicate[filePath]) {
          loadModelPromises.push(loadModel(part, filePath));
          duplicate[filePath] = true;
        }
      }
      towerWithPart[modelName]["doorHardware"][part] = null;
    }

    // Knobs - from both drawer and door
    for (const part of hardware["drawer"].knob) {
      if (!part.includes("Extra")) {
        const filePath = baseUrl + "/new_models/pull/" + part + ".glb";
        if (!duplicate[filePath]) {
          loadModelPromises.push(loadModel(part, filePath));
          duplicate[filePath] = true;
        }
      }
      towerWithPart[modelName]["drawerHardware"][part] = null;
    }
    for (const part of hardware["door"].knob) {
      if (!part.includes("Extra")) {
        const filePath = baseUrl + "/new_models/pull/" + part + ".glb";
        if (!duplicate[filePath]) {
          loadModelPromises.push(loadModel(part, filePath));
          duplicate[filePath] = true;
        }
      }
      towerWithPart[modelName]["doorHardware"][part] = null;
    }
  }

  console.log(towerWithPart);
  const materialEdit = gui.addFolder("Edit Material");
  materialEdit.close();

  const WardrobeFolder = gui.addFolder("Choose First Wardrobe");

  function createWardrobeButtons() {
    // debugger;
    for (const objectName of bigWardrobeNames) {
      if (objects.hasOwnProperty(objectName)) {
        WardrobeFolder.add(
          {
            add: () => addBigWardrobeToScene(objectName, positions[objectName]),
          },
          "add"
        ).name(`Add ${objectName}`);
      }
    }
  }

  //

  const Top = gui.addFolder("Top");
  Top.add(
    {
      add: () => {
        for (let i = 0; i < document.cabinetsInScene.length; i++) {
          removeObjectFromSelectedCabinet("top", i);
        }
      },
    },
    "add"
  ).name(`Clear All Top`);
  Top.add(
    {
      add: () => {
        removeObjectFromSelectedCabinet(
          "top",
          document.CabinetVars.SelectedIndex
        );
      },
    },
    "add"
  ).name(`Clear Top For Selected`);
  Top.close();
  const Bottom = gui.addFolder("Bottom");
  Bottom.add(
    {
      add: () => {
        for (let i = 0; i < document.cabinetsInScene.length; i++) {
          removeObjectFromSelectedCabinet("bottom", i);
        }
      },
    },
    "add"
  ).name(`Clear All Bottom`);
  Bottom.add(
    {
      add: () => {
        removeObjectFromSelectedCabinet(
          "bottom",
          document.CabinetVars.SelectedIndex
        );
      },
    },
    "add"
  ).name(`Clear Bottom For Selected`);
  Bottom.close();
  const Door = gui.addFolder("Door");
  Door.add(
    {
      add: () => {
        for (let i = 0; i < document.cabinetsInScene.length; i++) {
          removeObjectFromSelectedCabinet("door", i);
        }
      },
    },
    "add"
  ).name(`Clear All Door`);
  Door.add(
    {
      add: () => {
        removeObjectFromSelectedCabinet(
          "door",
          document.CabinetVars.SelectedIndex
        );
      },
    },
    "add"
  ).name(`Clear Door For Selected`);
  Door.close();

  // Door angle control
  const doorAngleParams = {
    angleDegrees: (getDoorOpenAngle() * 180) / Math.PI, // Initialize from current value
    angleRadians: getDoorOpenAngle(),
  };

  const doorSettingsFolder = gui.addFolder("Door Settings");
  const degreesController = doorSettingsFolder
    .add(doorAngleParams, "angleDegrees", 0, 180, 1)
    .name("Door Open Angle (degrees)")
    .onChange((value) => {
      const angleRadians = (value * Math.PI) / 180;
      setDoorOpenAngle(angleRadians);
      // Update radians controller to stay in sync
      doorAngleParams.angleRadians = angleRadians;
      radiansController.updateDisplay();
    });
  const radiansController = doorSettingsFolder
    .add(doorAngleParams, "angleRadians", 0, Math.PI, 0.01)
    .name("Door Open Angle (radians)")
    .onChange((value) => {
      setDoorOpenAngle(value);
      // Update degrees controller to stay in sync
      doorAngleParams.angleDegrees = (value * 180) / Math.PI;
      degreesController.updateDisplay();
    });
  doorSettingsFolder.close();

  const removeObjectFromSelectedCabinet = (part, index, specificKey = null) => {
    const currentObject = document.cabinetsInScene[index];
    if (!currentObject || !currentObject.part || !currentObject.part[part]) {
      return;
    }
    if (specificKey) {
      const hardwareObject = currentObject.part[part][specificKey];
      if (hardwareObject) {
        scene.remove(hardwareObject);
        currentObject.part[part][specificKey] = null;
      }
    } else {
      for (const objectName of Object.keys(currentObject.part[part])) {
        const hardwareObject = currentObject.part[part][objectName];
        if (hardwareObject) {
          scene.remove(hardwareObject);
          currentObject.part[part][objectName] = null;
        }
      }
    }
  };

  const drawerHardware = gui.addFolder("Drawer Hardware"); //drawerHardware
  drawerHardware.close();
  drawerHardware
    .add(
      {
        add: () => {
          for (let i = 0; i < document.cabinetsInScene.length; i++) {
            removeObjectFromSelectedCabinet("drawerHardware", i);
          }
        },
      },
      "add"
    )
    .name(`Clear All Drawer Hardware`);
  drawerHardware
    .add(
      {
        add: () => {
          removeObjectFromSelectedCabinet(
            "drawerHardware",
            document.CabinetVars.SelectedIndex
          );
        },
      },
      "add"
    )
    .name(`Clear Drawer Hardware For Selected`);
  const doorHardware = gui.addFolder("Door Hardware"); //doorHardware
  doorHardware.close();

  doorHardware
    .add(
      {
        add: () => {
          for (let i = 0; i < document.cabinetsInScene.length; i++) {
            removeObjectFromSelectedCabinet("doorHardware", i);
          }
        },
      },
      "add"
    )
    .name(`Clear All Door Hardware`);
  doorHardware
    .add(
      {
        add: () => {
          removeObjectFromSelectedCabinet(
            "doorHardware",
            document.CabinetVars.SelectedIndex
          );
        },
      },
      "add"
    )
    .name(`Clear Door Hardware For Selected`);
  // Helper function to clean up display names
  function getHalfDoorDisplayName(modelName) {
    return modelName;
  }

  // Helper function to check if item is a half door
  function isHalfDoor(modelName) {
    const cleanName = modelName.replace("_TOP", "").replace("_BOTTOM", "");
    return (
      cleanName.includes("_HDO_") ||
      cleanName.includes("_HDP_") ||
      cleanName.endsWith("_HDO")
    );
  }

  for (let i = 0; i < bigWardrobeNames.length; i++) {
    const elements = elementParts[bigWardrobeNames[i]];
    const subTop = Top.addFolder(bigWardrobeNames[i]);
    subTop.close();

    for (let j = 0; j < elements.top.length; j++) {
      // Skip half doors as they're only in the door menu
      if (isHalfDoor(elements.top[j])) {
        continue;
      }

      if (elements.top[j].includes("Extra")) {
        const split = elements.top[j].split(" ");
        const modelName = split[1];
        const extraName = split[1] + "_" + split[2];
        subTop
          .add(
            {
              add: () =>
                addObjectToSelectedCabinet(
                  modelName,
                  extraName,
                  bigWardrobeNames[i],
                  "top"
                ),
            },
            "add"
          )
          .name(`Add ${elements.top[j]}`);
      } else {
        subTop
          .add(
            {
              add: () =>
                addObjectToSelectedCabinet(
                  elements.top[j],
                  elements.top[j],
                  bigWardrobeNames[i],
                  "top"
                ),
            },
            "add"
          )
          .name(`Add ${elements.top[j]}`);
      }
    }

    const subBottom = Bottom.addFolder(bigWardrobeNames[i]);
    subBottom.close();

    for (let j = 0; j < elements.bottom.length; j++) {
      // Skip half doors as they're only in the door menu
      if (isHalfDoor(elements.bottom[j])) {
        continue;
      }

      if (elements.bottom[j].includes("Extra")) {
        const split = elements.bottom[j].split(" ");
        const modelName = split[1];
        const extraName = split[1] + "_" + split[2];
        subBottom
          .add(
            {
              add: () =>
                addObjectToSelectedCabinet(
                  modelName,
                  extraName,
                  bigWardrobeNames[i],
                  "bottom"
                ),
            },
            "add"
          )
          .name(`Add ${elements.bottom[j]}`);
      } else {
        subBottom
          .add(
            {
              add: () =>
                addObjectToSelectedCabinet(
                  elements.bottom[j],
                  elements.bottom[j],
                  bigWardrobeNames[i],
                  "bottom"
                ),
            },
            "add"
          )
          .name(`Add ${elements.bottom[j]}`);
      }
    }
    const subDoor = Door.addFolder(bigWardrobeNames[i]);
    subDoor.close();

    for (let j = 0; j < elements.door.length; j++) {
      const displayName = getHalfDoorDisplayName(elements.door[j]);

      // Check if this is actually a half door (single _HDO or _HDO_L/R or _HDP_, NOT _FHD_)
      if (
        elements.door[j].includes("_HDO_") ||
        elements.door[j].includes("_HDP_") ||
        elements.door[j].endsWith("_HDO")
      ) {
        // For half doors, add both top and bottom options
        // Add option to place in top position (original position)
        subDoor
          .add(
            {
              add: () =>
                addObjectToSelectedCabinet(
                  elements.door[j],
                  elements.door[j] + "_TOP",
                  bigWardrobeNames[i],
                  "door",
                  0
                ),
            },
            "add"
          )
          .name(`Add ${displayName} (Top)`);

        // Add option to place in bottom position
        subDoor
          .add(
            {
              add: () =>
                addObjectToSelectedCabinet(
                  elements.door[j],
                  elements.door[j] + "_BOTTOM",
                  bigWardrobeNames[i],
                  "door",
                  -1.05
                ),
            },
            "add"
          )
          .name(`Add ${displayName} (Bottom)`);
      } else {
        // Regular doors go to door position (no top/bottom options)
        subDoor
          .add(
            {
              add: () =>
                addObjectToSelectedCabinet(
                  elements.door[j],
                  elements.door[j],
                  bigWardrobeNames[i],
                  "door"
                ),
            },
            "add"
          )
          .name(`Add ${displayName}`);
      }
    }

    const subDoorHardware = doorHardware.addFolder(bigWardrobeNames[i]);
    subDoorHardware.close();
    for (let j = 0; j < elements.doorHardware.length; j++) {
      if (elements.doorHardware[j].includes("Extra")) {
        const split = elements.doorHardware[j].split(" ");
        const modelName = split[1];
        const extraName = split[1] + "_" + split[2];
        subDoorHardware
          .add(
            {
              add: () =>
                addObjectToSelectedCabinet(
                  modelName,
                  extraName,
                  bigWardrobeNames[i],
                  "doorHardware"
                ),
            },
            "add"
          )
          .name(`Add ${elements.doorHardware[j]}`);
      } else {
        subDoorHardware
          .add(
            {
              add: () =>
                addObjectToSelectedCabinet(
                  elements.doorHardware[j],
                  elements.doorHardware[j],
                  bigWardrobeNames[i],
                  "doorHardware"
                ),
            },
            "add"
          )
          .name(`Add ${elements.doorHardware[j]}`);
      }
    }

    if (elements.drawerHardware) {
      const subDrawerHardware = drawerHardware.addFolder(bigWardrobeNames[i]);
      subDrawerHardware.close();
      for (let j = 0; j < elements.drawerHardware.length; j++) {
        if (elements.drawerHardware[j].includes("Extra")) {
          const split = elements.drawerHardware[j].split(" ");
          const modelName = split[1];
          const extraName = split[1] + "_" + split[2];
          subDrawerHardware
            .add(
              {
                add: () =>
                  addObjectToSelectedCabinet(
                    modelName,
                    extraName,
                    bigWardrobeNames[i],
                    "drawerHardware"
                  ),
              },
              "add"
            )
            .name(`Add ${elements.drawerHardware[j]}`);
        } else {
          subDrawerHardware
            .add(
              {
                add: () =>
                  addObjectToSelectedCabinet(
                    elements.drawerHardware[j],
                    elements.drawerHardware[j],
                    bigWardrobeNames[i],
                    "drawerHardware"
                  ),
              },
              "add"
            )
            .name(`Add ${elements.drawerHardware[j]}`);
        }
      }
    }
  }

  // Bulk Hardware Color Update
  const bulkHardwareColorFolder = gui.addFolder("Bulk Hardware Color");
  bulkHardwareColorFolder.close();
  const bulkColorOptions = {
    color: "BLACK",
  };
  bulkHardwareColorFolder
    .add(bulkColorOptions, "color", ["BLACK", "BRASS", "CHROME", "NICKEL"])
    .name("Hardware Color")
    .onChange((value) => {
      bulkUpdateHardwareColor(value);
    });
  bulkHardwareColorFolder
    .add(
      {
        update: () => bulkUpdateHardwareColor(bulkColorOptions.color),
      },
      "update"
    )
    .name("Update All Hardware Colors");

  const cameraOptionsFolder = gui.addFolder("CameraOptions");
  cameraOptionsFolder.close();
  let orbitControlsEnabled = true;
  const orbitButton = cameraOptionsFolder
    .add({ toggleOrbitControls: toggleOrbitControls }, "toggleOrbitControls")
    .name("Toggle Orbit Controls");

  function toggleOrbitControls() {
    if (orbitControlsEnabled) {
      //controls.reset();
      camera.position.set(cameraStartPos.x, cameraStartPos.y, cameraStartPos.z);
      camera.lookAt(cameraLookAt.x, cameraLookAt.y, cameraLookAt.z);
      controls.enabled = false;
      orbitControlsEnabled = false;
    } else {
      controls.enabled = true;
      orbitControlsEnabled = true;
      controls.target.set(cameraLookAt.x, cameraLookAt.y, cameraLookAt.z);
    }
  }

  //color control
  materialEdit.addColor(material, "color").name("Color");
  materialEdit.add(material, "roughness", 0, 1).name("Roughness");
  materialEdit.add(material, "metalness", 0, 1).name("Metalness");

  Promise.all(loadModelPromises)
    .then(() => {
      createWardrobeButtons();

      // createGUIButtonsTop();
      // createGUIButtonsBottom();
      // createGUIButtonsDoor();

      // createGUIButtonsW15Top();
      // createGUIButtonsW15Bottom();
      // createGUIButtonsW15Door();

      // Emit custom event when all models are loaded and ready
      // Use setTimeout to ensure document.App is set up (it's set synchronously after this Promise.all)
      let retryCount = 0;
      const maxRetries = 50; // Maximum 500ms wait time
      const emitReadyEvent = () => {
        if (document.App) {
          const readyEvent = new CustomEvent("closetConfiguratorReady", {
            detail: {
              app: document.App,
              modelsLoaded: true,
              timestamp: Date.now(),
            },
            bubbles: true,
            cancelable: true,
          });
          window.dispatchEvent(readyEvent);
        } else if (retryCount < maxRetries) {
          // If document.App isn't ready yet, wait a bit and try again
          retryCount++;
          setTimeout(emitReadyEvent, 10);
        } else {
          // Emit event anyway even if document.App isn't available (shouldn't happen)
          console.warn(
            "closetConfiguratorReady: document.App not available after waiting"
          );
          const readyEvent = new CustomEvent("closetConfiguratorReady", {
            detail: {
              app: null,
              modelsLoaded: true,
              timestamp: Date.now(),
            },
            bubbles: true,
            cancelable: true,
          });
          window.dispatchEvent(readyEvent);
        }
      };
      emitReadyEvent();
    })
    .catch((error) => {
      console.error("Error loading models:", error);
      // Emit error event
      const errorEvent = new CustomEvent("closetConfiguratorError", {
        detail: {
          error: error.message || error,
          timestamp: Date.now(),
        },
        bubbles: true,
        cancelable: true,
      });
      window.dispatchEvent(errorEvent);
    });

  //invisible plane for raycasting
  const planeGeometry = new THREE.PlaneGeometry(25, 25);
  const planeMaterial = new THREE.MeshBasicMaterial();
  planeMaterial.color.set(0xff0000);
  planeMaterial.visible = false;
  const raycastPlane = new THREE.Mesh(planeGeometry, planeMaterial);
  raycastPlane.position.set(0, 0, 0.7);
  raycastPlane.name = "Raycast plane";
  scene.add(raycastPlane);

  function areSpacesOccupied(modelObject, occupiedSpaces) {
    const spacesToCheck = modelObject.spaceId[modelObject.spaceIndex];

    for (const spaceId of spacesToCheck) {
      if (occupiedSpaces[spaceId].length > 0) {
        return true;
      }
    }

    return false;
  }

  var ListOfObjects = [];
  var ObjectsInScene = [];

  function addObjectToUnoccupiedSpaces(modelObject, occupiedSpaces) {
    const spacesToAddTo = modelObject.spaceId[modelObject.spaceIndex];

    if (modelObject.NameOfObject) ListOfObjects.push(modelObject.NameOfObject);
    ObjectsInScene.push(modelObject);

    for (const spaceId of spacesToAddTo) {
      if (occupiedSpaces[spaceId].length === 0) {
        occupiedSpaces[spaceId].push(modelObject);
      }
    }
  }
  function removeObjectFromAllSpaces(modelObject, occupiedSpaces) {
    const spacesToRemoveFrom = modelObject.spaceId[modelObject.spaceIndex];

    var indexToRemove = ListOfObjects.indexOf(modelObject.NameOfObject);
    if (indexToRemove !== -1) {
      ListOfObjects.splice(indexToRemove, 1);
      ObjectsInScene.splice(indexToRemove, 1);
    }

    var indexAtWhichToRemove = document.addedObjects.findIndex(
      (obj) => obj.NameOfObject === modelObject.NameOfObject
    );
    if (indexAtWhichToRemove !== -1) {
      document.addedObjects.splice(indexAtWhichToRemove, 1);
    }

    for (const spaceId of spacesToRemoveFrom) {
      const index = occupiedSpaces[spaceId].indexOf(modelObject);
      if (index !== -1) {
        occupiedSpaces[spaceId].splice(index, 1);
      }
    }

    scene.remove(modelObject);
  }

  function removeObjectsFromOccupiedSpaces(modelObject, occupiedSpaces) {
    const spacesToCheck = modelObject.spaceId[modelObject.spaceIndex];

    for (const spaceId of spacesToCheck) {
      const objectsInSpace = occupiedSpaces[spaceId];
      for (const object of objectsInSpace) {
        removeObjectFromAllSpaces(object, occupiedSpaces);
      }
    }
  }

  function removeObjectsFromSelectedOccupiedSpaces(
    spaceToCheck,
    occupiedSpaces
  ) {
    const spacesToCheck = spaceToCheck;

    for (const spaceId of spacesToCheck) {
      const objectsInSpace = occupiedSpaces[spaceId];
      for (const object of objectsInSpace) {
        removeObjectFromAllSpaces(object, occupiedSpaces);
      }
    }
  }
  function ResetSceneScene(instant = false) {
    scene.remove(radialShadowPlane);
    // Iterate in reverse to avoid index issues, and make a copy of the array
    const cabinetsToReset = [...document.cabinetsInScene];
    for (let i = cabinetsToReset.length - 1; i >= 0; i--) {
      removeObjectFromSelectedCabinet("top", i);
      removeObjectFromSelectedCabinet("bottom", i);
      removeObjectFromSelectedCabinet("door", i);
      removeObjectFromSelectedCabinet("doorHardware", i);
      removeObjectFromSelectedCabinet("drawerHardware", i);
    }
    ObjectsInScene.forEach((object) => {
      scene.remove(object);
    });
    ObjectsInScene = [];
    document.cabinetsInScene = [];
    selectionBars.forEach((object) => {
      scene.remove(object);
    });
    selectionBars = [];

    groupWidthMes.forEach((object) => {
      scene.remove(object);
    });
    groupWidthMes = [];

    for (let i = 0; i < Measurements.Width.length; i++) {
      let widthArray = Measurements.Width[i];
      for (let j = 0; j < widthArray.length; j++) {
        scene.remove(widthArray[j]);
      }
    }
    Measurements.Width = [];

    for (let i = 0; i < Measurements.Height.length; i++) {
      let heightArray = Measurements.Height[i];
      for (let j = 0; j < heightArray.length; j++) {
        scene.remove(heightArray[j]);
      }
    }
    Measurements.Height = [];

    for (let i = 0; i < Measurements.Depth.length; i++) {
      let depthArray = Measurements.Depth[i];
      for (let j = 0; j < depthArray.length; j++) {
        scene.remove(depthArray[j]);
      }
    }
    Measurements.Depth = [];

    cabinets = [];
    document.App.cabinets = cabinets;
    ListOfObjects = [];
    medianXPoint = 0;
    bigCabinets = [];
    smallCabinets = [];
    groupWidth.width = 0;
    cabinetWidths = [];
    console.log(
      `[DEBUG] ResetSceneScene - Reset all measurements: groupWidth.width = ${
        groupWidth.width
      }, cabinetWidths = [${cabinetWidths.join(", ")}]`
    );
    previousCabinetLength = 0;
    document.CabinetVars.SelectedIndex = 0;

    // Clean up any remaining hardware objects from document.addedObjects
    if (document.addedObjects) {
      document.addedObjects.forEach(function (obj) {
        if (obj && obj.parent === scene) {
          scene.remove(obj);
        }
      });
      document.addedObjects = [];
    }

    // Clean up any remaining orphaned objects (safety net)
    if (scene && scene.children) {
      const objectsToRemove = [];
      scene.children.forEach(function (child) {
        // Remove orphaned meshes without names (but keep named objects)
        if (child instanceof THREE.Mesh && !child.name) {
          objectsToRemove.push(child);
        }
      });
      objectsToRemove.forEach((obj) => {
        scene.remove(obj);
      });
    }

    (instant && resetCameraToStartInstant()) || ResetCameraToStart();
    // (instant && ResetCameraToStartInstantly()) || ResetCameraToStart();
    resetOccupiedSpaces();
  }
  function resetOccupiedSpaces() {
    occupiedSpaces[SpaceId.WARDROBE] = [];
    occupiedSpaces[SpaceId.MIDDLE] = [];
    occupiedSpaces[SpaceId.LEFTDOOR] = [];
    occupiedSpaces[SpaceId.RIGHTDOOR] = [];
    occupiedSpaces[SpaceId.SEVEN] = [];
    occupiedSpaces[SpaceId.SIX] = [];
    occupiedSpaces[SpaceId.FIVE] = [];
    occupiedSpaces[SpaceId.FOUR] = [];
    occupiedSpaces[SpaceId.THREE] = [];
    occupiedSpaces[SpaceId.TWO] = [];
    occupiedSpaces[SpaceId.ONE] = [];
    occupiedSpaces[SpaceId.ZERO] = [];
  }
  const removeFolder = gui.addFolder("Reset Scene");
  removeFolder
    .add(
      {
        remove: function () {
          ResetSceneScene();
        },
      },
      "remove"
    )
    .name("Reset Scene Button");

  function addBigWardrobeToScene(objectName, position) {
    console.log(
      `[DEBUG] addBigWardrobeToScene - Adding first cabinet: ${objectName}`
    );
    scene.add(radialShadowPlane);

    if (document.cabinetsInScene.length > 0) {
      removeObjectFromSelectedCabinet("top", 0);
      removeObjectFromSelectedCabinet("bottom", 0);
      removeObjectFromSelectedCabinet("door", 0);
      removeObjectFromSelectedCabinet("doorHardware", 0);
      removeObjectFromSelectedCabinet("drawerHardware", 0);
    }

    let object = objects[objectName];
    object.position.copy(position[0]);

    if (!areSpacesOccupied(object, occupiedSpaces)) {
      object.NameOfObject = objectName;

      addObjectToUnoccupiedSpaces(object, occupiedSpaces);

      scene.add(object);

      document.cabinetsInScene.push(object);

      var startBigCabinet = deepCloneCabinet(object);
      cabinets.push(startBigCabinet);
      bigCabinets.push(startBigCabinet);
      addBigSnapPositions(0);
    } else {
      removeObjectsFromOccupiedSpaces(object, occupiedSpaces);
      groupWidth.width = 0;

      document.cabinetsInScene.pop();
      cabinets.pop();
      bigCabinets.pop();
      removeLastBigSnapPositions();

      removeLastSelectionBar();

      object.NameOfObject = objectName;
      addObjectToUnoccupiedSpaces(object, occupiedSpaces);
      scene.add(object);

      document.cabinetsInScene.push(object);

      var startBigCabinet = deepCloneCabinet(object);
      cabinets.push(startBigCabinet);
      bigCabinets.push(startBigCabinet);
      addBigSnapPositions(0);
    }

    AddSelectionBar(new THREE.Vector3(0, 0, 0), false);

    isLastCabinetBig = true;
    let isItBig = isLastCabinetBig;
    CabinetSizesArray.push(isItBig);

    removeLastMeasurement();
    removeHeightMes();
    removeDepthMes();
    removeGroupedMes();
    createArrowsWidth(scene, object, 0.45, object.name, font);
    createArrowsHeight(scene, object, 1.2, object.name, font, mesVisibility);
    createArrowsDepth(scene, object, 1.2, object.name, font, mesVisibility);

    renderer.render(scene, camera);
  }

  // const addedObjects = [];
  document.addedObjects = [];

  function addObjectToSelectedCabinet(
    objectName,
    extraName = "",
    parentName = "",
    part = "",
    offset = 0
  ) {
    // debugger;
    const currentObject =
      document.cabinetsInScene[document.CabinetVars.SelectedIndex];
    if (currentObject.name !== parentName) {
      return;
    }
    if (currentObject.part[part][extraName]) {
      return;
    }
    let object = deepCloneObject(objects[objectName]);

    // Apply global hardware color to rods when they're added
    if (
      objectName.includes("_ROD") &&
      !objectName.match(/_ROD_(BLACK|BRASS|CHROME|NICKEL)/)
    ) {
      // This is a rod without a color suffix - apply global color
      const globalColor = document.globalHardwareColor || "CHROME";
      const rodMaterial = getRodMaterial(globalColor);
      object.traverse((child) => {
        if (child.isMesh) {
          const clonedMat = rodMaterial.clone();
          if (typeof EnvTex !== "undefined" && EnvTex) {
            clonedMat.envMap = EnvTex;
            clonedMat.envMapIntensity = 0.9;
          }
          child.material = clonedMat;
          child.material.needsUpdate = true;
        }
      });
      // Update the object name to include the color
      object.NameOfObject = objectName.replace(/_ROD/, `_ROD_${globalColor}`);
    } else if (objectName.includes("_ROD")) {
      // Rod with color suffix - ensure material has envMap
      object.traverse((child) => {
        if (child.isMesh) {
          if (
            typeof EnvTex !== "undefined" &&
            EnvTex &&
            !child.material.envMap
          ) {
            child.material.envMap = EnvTex;
            child.material.envMapIntensity = 0.9;
            child.material.needsUpdate = true;
          }
        }
      });
    }

    let position = null;
    if (part === "doorHardware" || part === "drawerHardware") {
      if (extraName !== objectName) {
        const split = extraName.split("_");
        const lastPart = split[split.length - 1];
        position = positions[part].find(
          (position) =>
            extraName.toLowerCase().includes(position.name.toLowerCase()) &&
            position.extraName?.toLowerCase() === lastPart.toLowerCase()
        );
      } else {
        position = positions[part].find((position) =>
          extraName.toLowerCase().includes(position.name.toLowerCase())
        );
      }
    } else {
      position = positions[part].find((position) =>
        extraName.toLowerCase().includes(position.name.toLowerCase())
      );
    }

    if (position) {
      object.position.set(
        position.position[0].x + currentObject.position.x,
        position.position[0].y + offset,
        position.position[0].z //+ offset
      );
      if (position.rotation) {
        object.rotation.set(
          position.rotation[0].x,
          position.rotation[0].y,
          position.rotation[0].z
        );
      }
    }
    object.NameOfObject = objectName;
    if (part === "doorHardware" || part === "drawerHardware") {
      // debugger;
      const group = new THREE.Group();
      const obj = currentObject.children[0].children[0];
      const box = new THREE.Box3().setFromObject(obj);
      if (objectName.toLowerCase().includes("_s")) {
        object.position.x = box.max.x - 0.08;
      }
      if (
        objectName.toLowerCase().includes("_l") ||
        objectName.toLowerCase().includes("_s")
      ) {
        group.position.set(box.min.x + 0.01, 0.618, box.max.z);

        // const cube = new THREE.BoxGeometry(0.01, 0.01, 0.01);
        // const cubeMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
        // const cubeMesh = new THREE.Mesh(cube, cubeMaterial);
        // cubeMesh.position.copy(group.position);
        // scene.add(cubeMesh);
      } else {
        group.position.set(box.max.x - 0.01, 0.618, box.max.z);

        // const cube = new THREE.BoxGeometry(0.01, 0.01, 0.01);
        // const cubeMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
        // const cubeMesh = new THREE.Mesh(cube, cubeMaterial);
        // cubeMesh.position.copy(group.position);
        // scene.add(cubeMesh);
      }

      group.attach(object);
      scene.add(group);
      currentObject.part[part][extraName] = group;
      document.addedObjects.push(group);
    } else {
      scene.add(object);
      currentObject.part[part][extraName] = object;
      document.addedObjects.push(object);
    }
  }

  const Animfolder = gui.addFolder("Object Animations");
  Animfolder.close();
  // document.Animfolder = gui.addFolder("Object Animations");

  function deepCloneObject(originalObject) {
    var clonedObject = originalObject.clone();

    // Copy the properties
    clonedObject.snapPosition = originalObject.snapPosition;
    clonedObject.spaceId = originalObject.spaceId;
    clonedObject.spaceIndex = originalObject.spaceIndex;
    clonedObject.snapped = originalObject.snapped;
    //clonedObject.boxes = originalObject.boxes;
    clonedObject.model = originalObject.model;

    clonedObject.part = towerWithPart[originalObject.name]
      ? JSON.parse(JSON.stringify(towerWithPart[originalObject.name]))
      : {};
    return clonedObject;
  }

  let isMaterialOne = true;
  // function swapMaterialForHandles(objectsArray, newMaterial1, newMaterial2) {
  //   objectsArray.forEach((object) => {
  //     if (
  //       object.NameOfObject === "LeftHandle_W30" ||
  //       object.NameOfObject === "RightHandle_W30" ||
  //       object.NameOfObject === "Handle_W15"
  //     ) {
  //       if (object.children.length > 0) {
  //         const firstChild = object.children[0];
  //         if (firstChild) {
  //           firstChild.traverse((child) => {
  //             if (child.isMesh) {
  //               child.material = isMaterialOne ? newMaterial1 : newMaterial2;
  //             }
  //           });
  //         }
  //       }
  //     }
  //   });
  // }

  // function swapMaterialForHandlesToggle() {
  //   isMaterialOne = !isMaterialOne;
  //   swapMaterialForHandles(
  //     ObjectsInScene,
  //     chromeMaterial,
  //     chromeMaterialBrushed
  //   );
  // }

  // const HandleMaterial = gui.addFolder("Handle Material Test");
  // HandleMaterial.close();
  // HandleMaterial.add(
  //   { swapMaterialForHandlesToggle: swapMaterialForHandlesToggle },
  //   "swapMaterialForHandlesToggle"
  // ).name("Swap Material For Handles");

  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////// SCREENSHOTS STARTS ////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////// GUI

  const screenshotFolder = gui.addFolder("Screenshot Button");
  screenshotFolder.close();

  screenshotFolder
    .add(
      {
        downloadScreenshotOpenDoors: downloadScreenshotOpenDoors,
      },
      "downloadScreenshotOpenDoors"
    )
    .name("Capture Screenshot Open doors");

  screenshotFolder
    .add(
      { downloadScreenshotCloseDoors: downloadScreenshotCloseDoors },
      "downloadScreenshotCloseDoors"
    )
    .name("Capture Screenshot Close Doors");

  ////////////////////////////////////////// MAIN FUNCTIONS

  function captureScreenshot(doorsOpen = true, quality = null) {
    DisableEnableSelectionBars(false);

    toggleVisibilitySS(paramsSS.toggleMeasurments);
    if (doorsOpen) {
      openAllDoorsInstant(cabinets, cabinets.length - 1);
    }
    if (doorsOpen) {
      renderer.render(scene, angleCamera);
    } else {
      renderer.render(scene, angleCamera2);
    }
    var img = new Image();

    img.onload = function () {
      // Calculate the scaling factor to fit within a 1920x1080 bounding box
      var scaleFactor = Math.min(1920 / img.width, 1080 / img.height);

      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");

      canvas.width = img.width * scaleFactor;
      canvas.height = img.height * scaleFactor;

      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    };
    img.src = quality
      ? renderer.domElement.toDataURL("image/jpeg", quality)
      : renderer.domElement.toDataURL();
    var sizeInBytes =
      img.src.length * (3 / 4) -
      (img.src.indexOf("=") > 0 ? img.src.length - img.src.indexOf("=") : 0);
    if (doorsOpen) {
      closeAllDoorsInstant(cabinets, cabinets.length - 1);
    }
    DisableEnableSelectionBars(true);
    return {
      image: img.src,
      sizeInBytes,
    };
  }

  ////////////////////////////////////////// HELPER FUNCTIONS

  function toggleVisibilitySS(visibility) {
    for (let i = 0; i < Measurements.Width.length; i++) {
      let widthArray = Measurements.Width[i];
      for (let j = 0; j < widthArray.length; j++) {
        widthArray[j].visible = visibility;
      }
    }
    for (let i = 0; i < heightMes.length; i++) {
      heightMes[i].visible = visibility;
    }
    for (let i = 0; i < depthMes.length; i++) {
      depthMes[i].visible = visibility;
    }
    // Toggle visibility for the group
    for (let i = 0; i < groupWidthMes.length; i++) {
      groupWidthMes[i].visible = visibility;
    }
    mesGroupVisibility = visibility;
  }

  ////////////////////////////////////////// GUI FUNCTIONS

  function downloadScreenshotCloseDoors() {
    var src = captureScreenshot(false, null).image;
    var a = document.createElement("a");
    // renderer.render(scene, camera);

    a.href = src.replace("image/png", "image/octet-stream");
    a.download = "canvas.png";
    a.click();
  }
  function downloadScreenshotOpenDoors() {
    const src = captureScreenshot(true, null).image;
    const a = document.createElement("a");

    a.href = src.replace("image/png", "image/octet-stream");
    a.download = "canvas.png";
    a.click();
  }

  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////// SCREENSHOTS ENDS //////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////

  const paramsSS = {
    toggleMeasurments: true,
  };

  screenshotFolder
    .add(paramsSS, "toggleMeasurments")
    .name("Display Measurments")
    .onChange(function (value) {
      // This function will be called when the toggle button is clicked
      if (value) {
        //toggleVisibility();
        //toggleVisibilityGroup();
      } else {
        //toggleVisibility();
        //toggleVisibilityGroup();
      }
    });

  const shadowControls = {
    toggleShadows: function () {
      light.castShadow = !light.castShadow;
    },
  };

  const shadowFolder = gui.addFolder("Shadow Controls");
  shadowFolder.close();

  shadowFolder.add(shadowControls, "toggleShadows").name("Toggle Shadows");

  function DisableEnableSelectionBars(enable = true) {
    if (selectionBars) {
      for (let i = 0; i < selectionBars.length; i++) {
        if (i === document.CabinetVars.SelectedIndex) {
          selectionBars[i].visible = enable;
        }
      }
    }
  }

  const wireframeControls = {
    wireframesEnabled: false,

    toggleWireframes: function () {
      this.wireframesEnabled = !this.wireframesEnabled;

      ObjectsInScene.forEach((object) => {
        object.traverse(function (child) {
          if (child instanceof Wireframe) {
            child.visible = wireframeControls.wireframesEnabled;
          }
        });
      });
    },
  };
  const wireframeFolder = gui.addFolder("Frame Controls");
  wireframeFolder.close();

  wireframeFolder
    .add(wireframeControls, "toggleWireframes")
    .name("Toggle Frames");

  const animationFunctions = [
    {
      name: "Open Left Door",
      func: () => {
        const cabinet =
          document.cabinetsInScene[document.CabinetVars.SelectedIndex];
        openLeftDoor(cabinet);
      },
    },
    {
      name: "Open Right Door",
      func: () => {
        const cabinet =
          document.cabinetsInScene[document.CabinetVars.SelectedIndex];
        openRightDoor(cabinet);
      },
    },
    {
      name: "Close Left Door",
      func: () => {
        const cabinet =
          document.cabinetsInScene[document.CabinetVars.SelectedIndex];
        closeLeftDoor(cabinet);
      },
    },
    {
      name: "Close Right Door",
      func: () => {
        const cabinet =
          document.cabinetsInScene[document.CabinetVars.SelectedIndex];
        closeRightDoor(cabinet);
      },
    },
    // {
    //   name: "Open Bottom Drawer",
    //   func: () =>
    //     openBottomDrawer(cabinets[document.CabinetVars.SelectedIndex]),
    // },
    // {
    //   name: "Close Bottom Drawer",
    //   func: () =>
    //     closeBottomDrawer(cabinets[document.CabinetVars.SelectedIndex]),
    // },
    // {
    //   name: "Open Middle Drawer",
    //   func: () =>
    //     openMiddleDrawer(cabinets[document.CabinetVars.SelectedIndex]),
    // },
    // {
    //   name: "Close Middle Drawer",
    //   func: () =>
    //     closeMiddleDrawer(cabinets[document.CabinetVars.SelectedIndex]),
    // },
    // {
    //   name: "Open Top Drawer",
    //   func: () => openTopDrawer(cabinets[document.CabinetVars.SelectedIndex]),
    // },
    // {
    //   name: "Close Top Drawer",
    //   func: () => closeTopDrawer(cabinets[document.CabinetVars.SelectedIndex]),
    // },
    // {
    //   name: "Open Chest Bottom Drawer",
    //   func: () =>
    //     openChestBottomDrawer(cabinets[document.CabinetVars.SelectedIndex]),
    // },
    // {
    //   name: "Open Chest Middle Drawer",
    //   func: () =>
    //     openChestMiddleDrawer(cabinets[document.CabinetVars.SelectedIndex]),
    // },
    // {
    //   name: "Open Chest Top Drawer",
    //   func: () =>
    //     openChestTopDrawer(cabinets[document.CabinetVars.SelectedIndex]),
    // },
    // {
    //   name: "Close Chest Bottom Drawer",
    //   func: () =>
    //     closeChestBottomDrawer(cabinets[document.CabinetVars.SelectedIndex]),
    // },
    // {
    //   name: "Close Chest Middle Drawer",
    //   func: () =>
    //     closeChestMiddleDrawer(cabinets[document.CabinetVars.SelectedIndex]),
    // },
    // {
    //   name: "Close Chest Top Drawer",
    //   func: () =>
    //     closeChestTopDrawer(cabinets[document.CabinetVars.SelectedIndex]),
    // },
  ];

  function openAllDoorsInstant(cabinets, maxIndex) {
    for (let i = 0; i <= maxIndex; i++) {
      openLeftDoorInstant(cabinets[i]);
      openRightDoorInstant(cabinets[i]);
    }
  }

  function closeAllDoorsInstant(cabinets, maxIndex) {
    for (let i = 0; i <= maxIndex; i++) {
      closeLeftDoorInstant(cabinets[i]);
      closeRightDoorInstant(cabinets[i]);
    }
  }
  // Add buttons for each animation function
  animationFunctions.forEach((animation) => {
    Animfolder.add({ [animation.name]: animation.func }, animation.name);
  });
  // Bulk update hardware colors function
  function bulkUpdateHardwareColor(color) {
    const colors = ["BLACK", "BRASS", "CHROME", "NICKEL"];
    if (!colors.includes(color)) {
      console.error(
        "Invalid color. Must be one of: BLACK, BRASS, CHROME, NICKEL"
      );
      return;
    }

    // Update global hardware color state
    document.globalHardwareColor = color;

    const originalSelectedIndex = document.CabinetVars.SelectedIndex;

    // Update all cabinets
    for (let i = 0; i < document.cabinetsInScene.length; i++) {
      const cabinet = document.cabinetsInScene[i];
      if (!cabinet || !cabinet.part) continue;

      // Temporarily set selected index to current cabinet
      document.CabinetVars.SelectedIndex = i;

      // Update rods in top and bottom
      ["top", "bottom"].forEach((partType) => {
        if (cabinet.part[partType]) {
          Object.keys(cabinet.part[partType]).forEach((key) => {
            const obj = cabinet.part[partType][key];
            if (obj && obj.NameOfObject && obj.NameOfObject.includes("_ROD")) {
              // Rods use the same model with different materials
              // Just update the material on the existing rod object
              const rodMaterial = getRodMaterial(color);

              // Traverse the rod object and update all mesh materials
              let materialUpdated = false;
              obj.traverse((child) => {
                if (child.isMesh) {
                  const clonedMaterial = rodMaterial.clone();
                  // Ensure environment map is applied if available
                  if (typeof EnvTex !== "undefined" && EnvTex) {
                    clonedMaterial.envMap = EnvTex;
                    clonedMaterial.envMapIntensity = 0.9;
                  }
                  // If material is an array, update all materials
                  if (Array.isArray(child.material)) {
                    child.material = child.material.map(() => {
                      const mat = clonedMaterial.clone();
                      if (typeof EnvTex !== "undefined" && EnvTex) {
                        mat.envMap = EnvTex;
                        mat.envMapIntensity = 0.9;
                      }
                      mat.needsUpdate = true;
                      return mat;
                    });
                  } else {
                    child.material = clonedMaterial;
                    child.material.needsUpdate = true;
                  }
                  materialUpdated = true;
                }
              });

              if (!materialUpdated) {
                console.warn(
                  `No meshes found in rod object: ${obj.NameOfObject}`
                );
              }

              // Update the object's name to reflect the new color
              let baseName;
              if (obj.NameOfObject.match(/_ROD_(BLACK|BRASS|CHROME|NICKEL)/)) {
                baseName = obj.NameOfObject.replace(
                  /_ROD_(BLACK|BRASS|CHROME|NICKEL).*/,
                  "_ROD"
                );
              } else {
                baseName = obj.NameOfObject.replace(/_ROD.*/, "_ROD");
              }

              const newRodName = baseName + "_" + color;
              obj.NameOfObject = newRodName;

              // Update the reference in objects if it exists
              if (objects[obj.name]) {
                // Keep the same object but update the name reference
                const oldName = obj.name;
                obj.name = newRodName;
                objects[newRodName] = objects[oldName];
                if (oldName !== newRodName) {
                  delete objects[oldName];
                }
              }
            }
          });
        }
      });

      // Update door hardware
      if (cabinet.part.doorHardware) {
        Object.keys(cabinet.part.doorHardware).forEach((key) => {
          const hardwareGroup = cabinet.part.doorHardware[key];
          if (
            hardwareGroup &&
            hardwareGroup.children &&
            hardwareGroup.children.length > 0
          ) {
            const hardwareObj = hardwareGroup.children[0];
            if (hardwareObj && hardwareObj.NameOfObject) {
              const oldName = hardwareObj.NameOfObject;
              // Replace color in hardware name
              const newName =
                oldName.replace(/_BLACK|_BRASS|_CHROME|_NICKEL/g, "") +
                "_" +
                color;

              if (objects[newName]) {
                // Remove old hardware
                scene.remove(hardwareGroup);
                cabinet.part.doorHardware[key] = null;

                // Add new hardware with selected color
                addObjectToSelectedCabinet(
                  newName,
                  key,
                  cabinet.name,
                  "doorHardware"
                );
              }
            }
          }
        });
      }

      // Update drawer hardware
      if (cabinet.part.drawerHardware) {
        Object.keys(cabinet.part.drawerHardware).forEach((key) => {
          const hardwareGroup = cabinet.part.drawerHardware[key];
          if (
            hardwareGroup &&
            hardwareGroup.children &&
            hardwareGroup.children.length > 0
          ) {
            const hardwareObj = hardwareGroup.children[0];
            if (hardwareObj && hardwareObj.NameOfObject) {
              const oldName = hardwareObj.NameOfObject;
              // Replace color in hardware name
              const newName =
                oldName.replace(/_BLACK|_BRASS|_CHROME|_NICKEL/g, "") +
                "_" +
                color;

              if (objects[newName]) {
                // Remove old hardware
                scene.remove(hardwareGroup);
                cabinet.part.drawerHardware[key] = null;

                // Add new hardware with selected color
                addObjectToSelectedCabinet(
                  newName,
                  key,
                  cabinet.name,
                  "drawerHardware"
                );
              }
            }
          }
        });
      }
    }

    // Restore original selected index
    document.CabinetVars.SelectedIndex = originalSelectedIndex;

    // Ensure scene background is not changed (fix for background color issue)
    // Don't modify scene background - it should remain as set initially
    // The background is managed by the toggleColor function and should not be changed here
  }

  document.App = {
    positions: positions,
    addBigWardrobeToScene: addBigWardrobeToScene, // Adds first cabinet as W30 or Swaps W15 to W30
    // addBigAdditionalCabinetF: addBigAdditionalCabinetFilled, // Adds additional small cabinet starting from 2nd
    addObjectToSelectedCabinet: addObjectToSelectedCabinet, // Adds elements to selected cabinet
    toggleOrbitControls: toggleOrbitControls, // Toggles Camera movement
    removeLastCabinet: removeLastCabinet,

    removeObjectFromSelectedCabinet: removeObjectFromSelectedCabinet,
    bulkUpdateHardwareColor: bulkUpdateHardwareColor, // Bulk update all hardware colors
    getGlobalHardwareColor: () => document.globalHardwareColor || "CHROME", // Get current global hardware color
    setGlobalHardwareColor: (color) => {
      const colors = ["BLACK", "BRASS", "CHROME", "NICKEL"];
      if (colors.includes(color)) {
        document.globalHardwareColor = color;
        bulkUpdateHardwareColor(color);
      }
    }, // Set global hardware color and update all hardware
    material: material,
    materialNoAO: materialNoAO,
    spaceId: SpaceId,

    cabinets: cabinets,
    openLeftDoor: openLeftDoor,
    openRightDoor: openRightDoor,
    closeLeftDoor: closeLeftDoor,
    closeRightDoor: closeRightDoor,
    openLeftDoorInstant: openLeftDoorInstant,
    openRightDoorInstant: openRightDoorInstant,
    closeLeftDoorInstant: closeLeftDoorInstant,
    closeRightDoorInstant: closeRightDoorInstant,

    resetScene: ResetSceneScene,
    toggleVisibility: toggleVisibility,
    toggleVisibilityGroup: toggleVisibilityGroup,
    closeAllDoorsInstant: closeAllDoorsInstant,
    //Can add any other function needed in same manner

    createCloset: createCloset,
    testBuildCloset: testBuildCloset,
    testBuildCloset2: testBuildCloset2,

    // screenshots
    captureScreenshot: captureScreenshot,
    captureScreenshotAngleBlob: captureScreenshot(false, null),
    captureScreenshotPerspectiveFromSetAngle: captureScreenshot(true, null),

    addAdditionalCabinet: addAdditionalCabinet,

    // New methods for testing
    getCabinetCount: () => cabinets.length,
    getCabinetWidths: () => [...cabinetWidths],
    getGroupWidth: () => groupWidth.width,
    setCameraMoveInstant: (value) => {
      MoveCamInstant = !!value;
      if (!MoveCamInstant) {
        clearTimeout(moveCamTimer);
      }
    },
    setCameraInstantTimeoutMs: (ms) => {
      const n = Number(ms);
      if (!Number.isNaN(n) && n >= 0) {
        cameraInstantTimeoutMs = n;
      }
    },
    getCameraMoveInstant: () => !!MoveCamInstant,
  };

  var event = new CustomEvent("readyToLoad", {
    detail: "Ready",
  });

  // Dispatch (emit) the event on the document or a specific DOM element
  document.dispatchEvent(event);

  function removeLastMeasurement() {
    if (Measurements.Width.length > 0) {
      let lastWidthArray = Measurements.Width.pop();
      for (let i = 0; i < lastWidthArray.length; i++) {
        scene.remove(lastWidthArray[i]);
      }
    }
    /*
    if (Measurements.Height.length > 0) {
      let lastWidthArray = Measurements.Height.pop();
      for (let i = 0; i < lastWidthArray.length; i++) {
        scene.remove(lastWidthArray[i]);
      }
    }
    */
  }
  function removeHeightMes() {
    if (heightMes.length > 0) {
      let lastWidthArray = heightMes;
      for (let i = 0; i < lastWidthArray.length; i++) {
        scene.remove(lastWidthArray[i]);
      }
    }
  }
  function removeDepthMes() {
    if (depthMes.length > 0) {
      let lastWidthArray = depthMes;
      for (let i = 0; i < lastWidthArray.length; i++) {
        scene.remove(lastWidthArray[i]);
      }
    }
  }
  function removeGroupedMes() {
    if (groupWidthMes.length > 0) {
      let lastWidthArray = groupWidthMes;
      for (let i = 0; i < lastWidthArray.length; i++) {
        scene.remove(lastWidthArray[i]);
      }
    }
  }

  let mesVisibility = true;
  function toggleVisibility() {
    for (let i = 0; i < Measurements.Width.length; i++) {
      let widthArray = Measurements.Width[i];
      for (let j = 0; j < widthArray.length; j++) {
        widthArray[j].visible = !widthArray[j].visible;
      }
    }
    /*
    for (let i = 0; i < Measurements.Height.length; i++) {
      let heightArray = Measurements.Height[i];
      for (let j = 0; j < heightArray.length; j++) {
        heightArray[j].visible = !heightArray[j].visible;
      }
    }
    */
    for (let i = 0; i < heightMes.length; i++) {
      heightMes[i].visible = !heightMes[i].visible;
    }
    for (let i = 0; i < depthMes.length; i++) {
      depthMes[i].visible = !depthMes[i].visible;
    }
    mesVisibility = !mesVisibility;
  }

  var visibilityFolder = gui.addFolder("Measurements");

  var visibilityController = visibilityFolder.add(
    {
      "Toggle Measurements": function () {
        toggleVisibility();
      },
    },
    "Toggle Measurements"
  );

  function toggleVisibilityGroup() {
    for (let i = 0; i < groupWidthMes.length; i++) {
      groupWidthMes[i].visible = !groupWidthMes[i].visible;
    }
    mesGroupVisibility = !mesGroupVisibility;
  }
  var visibilityControllerTwo = visibilityFolder.add(
    {
      "Toggle Measurements Group": function () {
        toggleVisibilityGroup();
      },
    },
    "Toggle Measurements Group"
  );

  let groupWidth = {
    width: 0,
    minX: 0,
    maxX: 0,
    maxZ: 0,
    maxY: 0,
    minY: 0,
  };

  // Add tracking array for cabinet widths
  let cabinetWidths = [];

  let offsetFromBottomFirstText = -0.05;
  let offsetFromBottomSecondText = -0.17;
  let fontSize = 0.04;

  function updateGroupedWidthArrows(objectList) {
    groupWidthMes.forEach((mesh) => {
      scene.remove(mesh);
    });

    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxZ = -Infinity;

    objectList.forEach((object) => {
      const model = object.children[0].children[0];
      model.geometry.computeBoundingBox();
      const boundingBox = model.geometry.boundingBox;

      minX = Math.min(minX, boundingBox.min.x + object.position.x);
      maxX = Math.max(maxX, boundingBox.max.x + object.position.x);
      minY = Math.min(minY, boundingBox.min.y + object.position.y);
      maxZ = Math.max(maxZ, boundingBox.max.z + object.position.z);
    });

    const middlePointG = (minX + maxX) / 2;
    const widthG = maxX - minX;

    const headWidth = 0.06;
    const bodyWidth = 0.0075;

    const bigC = bigCabinets.length * 0.4;
    const smallC = smallCabinets.length * 0.2;
    const T = bigC + smallC;
    const totalCabinets = bigCabinets.length + smallCabinets.length;

    let spaceG;
    //spaceG = 0.5 + T * (1 - decreaseFactor);
    spaceG = 0.5 + T;
    if (totalCabinets === 1) {
      spaceG = 0.565;
    }

    const halfSpaceG = spaceG / 2;
    const bodyGeometryG = new THREE.PlaneGeometry(
      widthG - spaceG - headWidth,
      bodyWidth
    );

    const headMaterial = new THREE.MeshBasicMaterial({ color: 0x2b87c9 });

    const leftStartXG = middlePointG - halfSpaceG;
    const rightStartXG = middlePointG + halfSpaceG;

    const bodyMaterial = new THREE.MeshBasicMaterial({ color: 0x000000 });
    const headGeometry = new THREE.PlaneGeometry(0.06, 0.06);

    const leftBodyG = new THREE.Mesh(bodyGeometryG, bodyMaterial);
    const leftHeadG = new THREE.Mesh(headGeometry, headMaterial);

    leftBodyG.position.set(
      leftStartXG,
      minY + offsetFromBottomSecondText,
      maxZ + 0.1
    );
    leftHeadG.position.set(
      minX + headWidth / 2,
      minY + offsetFromBottomSecondText,
      maxZ + 0.1
    );
    leftHeadG.rotation.z = -Math.PI / 2;
    const rightBodyG = new THREE.Mesh(bodyGeometryG, bodyMaterial);
    const rightHeadG = new THREE.Mesh(headGeometry, headMaterial);

    rightBodyG.position.set(
      rightStartXG,
      minY + offsetFromBottomSecondText,
      maxZ + 0.1
    );
    rightHeadG.position.set(
      maxX - headWidth / 2,
      minY + offsetFromBottomSecondText,
      maxZ + 0.1
    );
    rightHeadG.rotation.z = Math.PI / 2;

    // Calculate total width including panel thickness (0.75" per cabinet)
    const totalWidth = groupWidth.width + (cabinets.length + 1) * 0.75;
    console.log(
      `[DEBUG] updateGroupedWidthArrows - Total width calculation: base width ${
        groupWidth.width
      } + panel thickness ${(cabinets.length + 1) * 0.75} = ${totalWidth}"`
    );
    const widthString = totalWidth.toString() + '"';

    const geometryG = new TextGeometry(widthString, {
      font: font,
      size: 0.1,
      height: 0.001,
      curveSegments: 12,
      bevelEnabled: false,
    });

    geometryG.center();

    const textWidthG = new THREE.Mesh(geometryG, bodyMaterial);
    textWidthG.position.set(
      middlePointG,
      minY + offsetFromBottomSecondText,
      maxZ + 0.1
    );

    scene.add(textWidthG);
    scene.add(leftBodyG);
    scene.add(leftHeadG);
    scene.add(rightBodyG);
    scene.add(rightHeadG);

    groupWidthMes = [leftBodyG, leftHeadG, rightBodyG, rightHeadG, textWidthG];
  }
  css3DRenderer = new CSS3DRenderer();
  css3DRenderer.setSize(width, height);
  css3DRenderer.domElement.style.position = "absolute";
  css3DRenderer.domElement.style.top = 0;

  css3DRenderer.domElement.style.pointerEvents = "none";
  //css3DRenderer.domElement.style.opacity = 1;

  container.appendChild(css3DRenderer.domElement);

  //create3DCSSElement(0,2.2,0,0);

  gui.close();

  function testBuildCloset() {
    document.App.addBigWardrobeToScene(
      "30/30W_TOWER",
      document.App.positions["30/30W_TOWER"]
    );
    document.App.addAdditionalCabinet(
      "18/18W_TOWER",
      document.App.positions["18/18W_TOWER"]
    );
    document.CabinetVars.SelectedIndex = 1;
    // setTimeout(() => {
    document.App.addObjectToSelectedCabinet(
      "PULL_MODERN_S_BRASS",
      "PULL_MODERN_S_BRASS",
      `18/18W_TOWER`,
      "doorHardware"
    );
    // });
  }
  function testBuildCloset2() {
    document.App.addBigWardrobeToScene(
      "30/30W_TOWER",
      document.App.positions["30/30W_TOWER"]
    );
    document.App.addAdditionalCabinet(
      "18/18W_TOWER",
      document.App.positions["18/18W_TOWER"]
    );
    document.CabinetVars.SelectedIndex = 1;
    // setTimeout(() => {
    document.App.addObjectToSelectedCabinet(
      "PULL_MODERN_S_BRASS",
      "PULL_MODERN_S_BRASS",
      `18/18W_TOWER`,
      "doorHardware"
    );

    document.App.addAdditionalCabinet(
      "30/30W_TOWER",
      document.App.positions["30/30W_TOWER"]
    );
    document.CabinetVars.SelectedIndex = 2;
    // setTimeout(() => {
    document.App.addObjectToSelectedCabinet(
      "PULL_MODERN_L_BRASS",
      "PULL_MODERN_L_BRASS",
      `30/30W_TOWER`,
      "doorHardware"
    );
    document.App.addObjectToSelectedCabinet(
      "PULL_MODERN_R_BRASS",
      "PULL_MODERN_R_BRASS",
      `30/30W_TOWER`,
      "doorHardware"
    );
    // });
    // });
  }
  function moveCameraAlongOrbit(sliderValue, amount) {
    const minAngle = -Math.PI / 2;
    const maxAngle = Math.PI / 2;
    const sliderVal = sliderValue;

    const rotationAngle = minAngle + (maxAngle - minAngle) * (sliderVal / 100);

    const radius = 7.5;
    const newPosition = new THREE.Vector3();
    newPosition.x = radius * Math.sin(rotationAngle);
    newPosition.z = radius * Math.cos(rotationAngle);
    newPosition.y = camera.position.y;
    camera.position.copy(newPosition);

    controls.update();
  }

  orbitControlsFolder.close();

  const orbitSliderParams = {
    value: 50,
    min: 0,
    max: 100,
  };

  const orbitSliderController = orbitControlsFolder
    .add(
      orbitSliderParams,
      "value",
      orbitSliderParams.min,
      orbitSliderParams.max
    )
    .name("Orbit Movement");

  orbitSliderController.onChange(function (value) {
    const amount = value;
    moveCameraAlongOrbit(controls, amount);
  });

  //#region dimension arrows
  function createArrowsWidth(scene, objectPassed, textSpace, name, font) {
    const model = objectPassed.children[0].children[0]; //.children[0];

    model.geometry.computeBoundingBox();
    const boundingBox = model.geometry.boundingBox;
    const width = boundingBox.max.x - boundingBox.min.x;

    //This point can be used to position background for numbers.
    const middlePoint = (boundingBox.min.x + boundingBox.max.x) / 2;

    const space = textSpace || 0.45;

    const halfSpace = space / 2;

    const leftStartX = middlePoint - halfSpace;
    const rightStartX = middlePoint + halfSpace;

    let headWidth = 0.01;
    let headHeight = 0.06;
    let sidePanelWidth = 0.065;
    let bodyWidth = 0.0075;

    const bodyGeometry = new THREE.PlaneGeometry(
      width - space - headWidth - sidePanelWidth,
      bodyWidth
    );
    const bodyMaterial = new THREE.MeshBasicMaterial({ color: 0x2b87c9 });
    const headGeometry = new THREE.PlaneGeometry(headHeight, headWidth);
    const headMaterial = new THREE.MeshBasicMaterial({ color: 0x2b87c9 });

    const leftBody = new THREE.Mesh(bodyGeometry, bodyMaterial);
    const leftHead = new THREE.Mesh(headGeometry, headMaterial);

    leftBody.position.set(
      leftStartX + objectPassed.position.x,
      boundingBox.min.y + offsetFromBottomFirstText,
      boundingBox.max.z + 0.1
    );
    leftHead.position.set(
      boundingBox.min.x +
        headWidth / 2 +
        objectPassed.position.x +
        sidePanelWidth / 2,
      boundingBox.min.y + offsetFromBottomFirstText,
      boundingBox.max.z + 0.1
    );
    leftHead.rotation.z = -Math.PI / 2;

    const rightBody = new THREE.Mesh(bodyGeometry, bodyMaterial);
    const rightHead = new THREE.Mesh(headGeometry, headMaterial);

    rightBody.position.set(
      rightStartX + objectPassed.position.x,
      boundingBox.min.y + offsetFromBottomFirstText,
      boundingBox.max.z + 0.1
    );
    rightHead.position.set(
      boundingBox.max.x -
        headWidth / 2 +
        objectPassed.position.x -
        sidePanelWidth / 2,
      boundingBox.min.y + offsetFromBottomFirstText,
      boundingBox.max.z + 0.1
    );
    rightHead.rotation.z = Math.PI / 2;
    // debugger;
    const sizes = WardrobeSize.find((item) => item.name === name);
    if (!sizes) {
      return;
    }

    const geometry = new TextGeometry(sizes.width + '"', {
      font: font,
      size: fontSize,
      height: 0.001, // Thickness of the text
      curveSegments: 12,
      bevelEnabled: false,
    });

    geometry.center();

    const textWidth = new THREE.Mesh(geometry, bodyMaterial);
    textWidth.position.set(
      middlePoint + objectPassed.position.x,
      boundingBox.min.y + offsetFromBottomFirstText,
      boundingBox.max.z + 0.1
    );

    function createRoundedRectShape(width, height, radius) {
      const shape = new THREE.Shape();
      shape.moveTo(-width / 2 + radius, -height / 2);
      shape.lineTo(width / 2 - radius, -height / 2);
      shape.quadraticCurveTo(
        width / 2,
        -height / 2,
        width / 2,
        -height / 2 + radius
      );
      shape.lineTo(width / 2, height / 2 - radius);
      shape.quadraticCurveTo(
        width / 2,
        height / 2,
        width / 2 - radius,
        height / 2
      );
      shape.lineTo(-width / 2 + radius, height / 2);
      shape.quadraticCurveTo(
        -width / 2,
        height / 2,
        -width / 2,
        height / 2 - radius
      );
      shape.lineTo(-width / 2, -height / 2 + radius);
      shape.quadraticCurveTo(
        -width / 2,
        -height / 2,
        -width / 2 + radius,
        -height / 2
      );
      return shape;
    }

    const bgW = 0.18;
    const bgH = 0.08;
    const borderWidth = 0.01;
    const borderColor = 0x2b87c9;
    const cornerRadius = 0.03;
    const backgroundColor = 0xdbf0ff;

    const roundedRectShape = createRoundedRectShape(bgW, bgH, cornerRadius);
    const geometry1 = new THREE.ShapeGeometry(roundedRectShape);
    const material = new THREE.MeshBasicMaterial({ color: backgroundColor });
    const plane = new THREE.Mesh(geometry1, material);

    plane.position.copy(textWidth.position);

    // Create a border geometry
    const borderShape = createRoundedRectShape(
      bgW + borderWidth,
      bgH + borderWidth,
      cornerRadius
    );
    const borderGeometry = new THREE.ShapeGeometry(borderShape);
    const borderMaterial = new THREE.MeshBasicMaterial({ color: borderColor });

    // Create a mesh for the border
    const borderMesh = new THREE.Mesh(borderGeometry, borderMaterial);
    borderMesh.position.copy(plane.position);
    borderMesh.position.z -= 0.001;

    scene.add(borderMesh);

    scene.add(plane);
    scene.add(textWidth);

    scene.add(leftBody);
    scene.add(leftHead);
    scene.add(rightBody);
    scene.add(rightHead);

    let widthArrows = [
      leftBody,
      rightBody,
      leftHead,
      rightHead,
      textWidth,
      borderMesh,
      plane,
    ];
    for (let i = 0; i < widthArrows.length; i++) {
      widthArrows[i].visible = mesVisibility;
    }

    Measurements.Width.push(widthArrows);

    const widthFloat = parseFloat(sizes.width);

    console.log(
      `[DEBUG] Adding cabinet: ${name}, width: ${widthFloat}", current total: ${
        groupWidth.width
      }, new total: ${groupWidth.width + widthFloat}`
    );
    groupWidth.width += widthFloat;
    cabinetWidths.push(widthFloat);
    console.log(`[DEBUG] Cabinet widths array: [${cabinetWidths.join(", ")}]`);
    console.log(
      `[DEBUG] Current state - Total cabinets: ${
        cabinets.length
      }, groupWidth.width: ${
        groupWidth.width
      }, cabinetWidths: [${cabinetWidths.join(", ")}]`
    );

    groupWidth.maxX = boundingBox.max.x + objectPassed.position.x;
    if (Measurements.Width.length === 1) {
      groupWidth.minX = boundingBox.min.x;
      groupWidth.maxZ = boundingBox.max.z;
      groupWidth.maxY = boundingBox.max.y;
      groupWidth.minY = boundingBox.min.y;
    }

    const middlePointG = (groupWidth.minX + groupWidth.maxX) / 2;

    const widthG = groupWidth.maxX - groupWidth.minX;

    const bigC = bigCabinets.length * 0.4;
    const smallC = smallCabinets.length * 0.2;
    const T = bigC + smallC;
    const totalCabinets = bigCabinets.length + smallCabinets.length;
    const decreaseFactor = Math.log10(totalCabinets + 1) / 10;

    let spaceG;
    //spaceG = 0.5 + T * (1 - decreaseFactor);
    spaceG = 0.5 + T;
    if (totalCabinets === 1) {
      spaceG = 0.565;
    }

    const halfSpaceG = spaceG / 2.3;
    const bodyGeometryG = new THREE.PlaneGeometry(
      widthG - spaceG - headWidth + 0.07,
      bodyWidth
    );

    const leftStartXG = middlePointG - halfSpaceG;
    const rightStartXG = middlePointG + halfSpaceG;

    const leftBodyG = new THREE.Mesh(bodyGeometryG, bodyMaterial);
    const leftHeadG = new THREE.Mesh(headGeometry, headMaterial);

    leftBodyG.position.set(
      leftStartXG,
      groupWidth.minY + offsetFromBottomSecondText,
      groupWidth.maxZ + 0.1
    );
    leftHeadG.position.set(
      groupWidth.minX + headWidth / 2,
      groupWidth.minY + offsetFromBottomSecondText,
      groupWidth.maxZ + 0.1
    );
    leftHeadG.rotation.z = -Math.PI / 2;

    const rightBodyG = new THREE.Mesh(bodyGeometryG, bodyMaterial);
    const rightHeadG = new THREE.Mesh(headGeometry, headMaterial);

    rightBodyG.position.set(
      rightStartXG,
      groupWidth.minY + offsetFromBottomSecondText,
      groupWidth.maxZ + 0.1
    );
    rightHeadG.position.set(
      groupWidth.maxX - headWidth / 2,
      groupWidth.minY + offsetFromBottomSecondText,
      groupWidth.maxZ + 0.1
    );
    rightHeadG.rotation.z = Math.PI / 2;

    // Calculate total width including panel thickness (0.75" per cabinet)
    const totalWidth = groupWidth.width + (cabinets.length + 1) * 0.75;
    console.log(
      `[DEBUG] createArrowsWidth - Total width calculation: base width ${
        groupWidth.width
      } + panel thickness ${(cabinets.length + 1) * 0.75} = ${totalWidth}"`
    );
    const widthString = totalWidth.toString() + '"';

    const geometryG = new TextGeometry(widthString, {
      font: font,
      size: 0.04,
      height: 0.001, // Thickness of the text
      curveSegments: 12,
      bevelEnabled: false,
    });
    geometryG.center();

    const textWidthG = new THREE.Mesh(geometryG, bodyMaterial);
    textWidthG.position.set(
      middlePointG,
      groupWidth.minY + offsetFromBottomSecondText,
      groupWidth.maxZ + 0.1
    );

    const bgWidth = 0.18;
    const bgHeight = 0.08;

    const roundedRectShape1 = createRoundedRectShape(
      bgWidth,
      bgHeight,
      cornerRadius
    );

    const geometry2 = new THREE.ShapeGeometry(roundedRectShape1);
    const material1 = new THREE.MeshBasicMaterial({
      color: 0xdbf0ff,
      side: THREE.DoubleSide,
    });
    const plane1 = new THREE.Mesh(geometry2, material1);

    plane1.position.copy(textWidthG.position);

    const borderWidth1 = 0.01;
    const borderColor1 = 0x2b87c9;

    // Create a border geometry
    const borderShape1 = createRoundedRectShape(
      bgWidth + borderWidth1,
      bgHeight + borderWidth1,
      cornerRadius
    );
    const borderGeometry1 = new THREE.ShapeGeometry(borderShape1);
    const borderMaterial1 = new THREE.MeshBasicMaterial({
      color: borderColor1,
    });

    // Create a mesh for the border
    const borderMesh1 = new THREE.Mesh(borderGeometry1, borderMaterial1);
    borderMesh1.position.copy(plane1.position);
    borderMesh1.position.z -= 0.001;

    scene.add(borderMesh1);
    scene.add(plane1);
    scene.add(textWidthG);

    scene.add(leftBodyG);
    scene.add(leftHeadG);
    scene.add(rightBodyG);
    scene.add(rightHeadG);
    let groupedWidth = [
      leftBodyG,
      leftHeadG,
      rightBodyG,
      rightHeadG,
      textWidthG,
      borderMesh1,
      plane1,
    ];
    for (let i = 0; i < groupedWidth.length; i++) {
      groupedWidth[i].visible = mesGroupVisibility;
    }

    groupWidthMes = groupedWidth;
  }
  function createArrowsHeight(scene, objectPassed, textSpace, name, font) {
    const model = objectPassed.children[0].children[0];
    model.geometry.computeBoundingBox();
    const boundingBox = model.geometry.boundingBox;
    const height = boundingBox.max.y - boundingBox.min.y;
    const middlePoint = (boundingBox.min.y + boundingBox.max.y) / 2;
    const space = textSpace || 1;
    const halfSpace = space / 2.23;
    const topStartY = middlePoint + halfSpace;
    const bottomStartY = middlePoint - halfSpace;

    // Define dimensions for the body and head
    let headWidth = 0.1; // Adjust head width as needed
    let headHeight = 0.01; // Adjust head height as needed
    let bodyHeight = 0.008; // Body height

    // Create body geometry
    const bodyGeometry = new THREE.PlaneGeometry(
      bodyHeight,
      height - space - headHeight + 0.08
    );
    const bodyMaterial = new THREE.MeshBasicMaterial({ color: 0x2b87c9 });

    // Create head geometry (as a rectangle)
    const headGeometry = new THREE.PlaneGeometry(headWidth, headHeight);
    const headMaterial = new THREE.MeshBasicMaterial({ color: 0x2b87c9 });

    // Create top arrow components
    const topBody = new THREE.Mesh(bodyGeometry, bodyMaterial);
    topBody.position.set(
      boundingBox.min.x - 0.1,
      topStartY + 0.015,
      boundingBox.max.z + 0.1
    );

    const topHead = new THREE.Mesh(headGeometry, headMaterial);
    topHead.position.set(
      boundingBox.min.x - 0.1,
      boundingBox.max.y - headHeight / 0.8,
      boundingBox.max.z + 0.1
    );

    // Create bottom arrow components
    const bottomBody = new THREE.Mesh(bodyGeometry, bodyMaterial);
    bottomBody.position.set(
      boundingBox.min.x - 0.1,
      bottomStartY - 0.01,
      boundingBox.max.z + 0.1
    );

    const bottomHead = new THREE.Mesh(headGeometry, headMaterial);
    bottomHead.position.set(
      boundingBox.min.x - 0.1,
      boundingBox.min.y + headHeight / 0.4,
      boundingBox.max.z + 0.1
    );
    bottomHead.rotation.x = 0;

    // Retrieve size information
    const sizes = WardrobeSize.find((item) => item.name === name);
    if (!sizes) {
      return;
    }

    // Create text geometry
    const geometry = new TextGeometry(sizes.height + '"', {
      font: font,
      size: 0.04,
      height: 0.001, // Thickness of the text
      curveSegments: 12,
      bevelEnabled: false,
    });

    geometry.center();

    const textHeight = new THREE.Mesh(geometry, bodyMaterial);
    textHeight.position.set(
      boundingBox.min.x - 0.1,
      boundingBox.max.y / 2,
      boundingBox.max.z + 0.1
    );

    // Create a helper function to create rounded rectangle shapes
    function createRoundedRectShape(width, height, radius) {
      const shape = new THREE.Shape();
      shape.moveTo(-width / 2 + radius, -height / 2);
      shape.lineTo(width / 2 - radius, -height / 2);
      shape.quadraticCurveTo(
        width / 2,
        -height / 2,
        width / 2,
        -height / 2 + radius
      );
      shape.lineTo(width / 2, height / 2 - radius);
      shape.quadraticCurveTo(
        width / 2,
        height / 2,
        width / 2 - radius,
        height / 2
      );
      shape.lineTo(-width / 2 + radius, height / 2);
      shape.quadraticCurveTo(
        -width / 2,
        height / 2,
        -width / 2,
        height / 2 - radius
      );
      shape.lineTo(-width / 2, -height / 2 + radius);
      shape.quadraticCurveTo(
        -width / 2,
        -height / 2,
        -width / 2 + radius,
        -height / 2
      );
      return shape;
    }

    const bgW = 0.16;
    const bgH = 0.08;
    const borderWidth = 0.01;
    const borderColor = 0x2b87c9;
    const backgroundColor = 0xdbf0ff;
    const cornerRadius = 0.03; // Adjust this value for the desired corner radius

    // Create the rounded rectangle shape for the background
    const roundedRectShape = createRoundedRectShape(bgW, bgH, cornerRadius);
    const geometry1 = new THREE.ShapeGeometry(roundedRectShape);
    const material = new THREE.MeshBasicMaterial({
      color: backgroundColor,
      side: THREE.DoubleSide,
    });
    const plane = new THREE.Mesh(geometry1, material);
    plane.position.copy(textHeight.position);

    // Create the rounded rectangle shape for the border
    const borderShape = createRoundedRectShape(
      bgW + borderWidth,
      bgH + borderWidth,
      cornerRadius
    );
    const borderGeometry = new THREE.ShapeGeometry(borderShape);
    const borderMaterial = new THREE.MeshBasicMaterial({ color: borderColor });
    const borderMesh = new THREE.Mesh(borderGeometry, borderMaterial);
    borderMesh.position.copy(plane.position);
    borderMesh.position.z -= 0.001;

    // Add meshes to the scene
    scene.add(borderMesh);
    scene.add(plane);
    scene.add(textHeight);
    scene.add(topBody);
    scene.add(topHead);
    scene.add(bottomBody);
    scene.add(bottomHead);

    // Store references to the arrow components
    let heightArrows = [
      topBody,
      bottomBody,
      topHead,
      bottomHead,
      textHeight,
      borderMesh,
      plane,
    ];
    heightMes = heightArrows;
    Measurements.Height.push(heightArrows);

    // Set height visibility on reset
    for (let i = 0; i < Measurements.Height.length; i++) {
      Measurements.Height[i].forEach((h) => (h.visible = mesVisibility));
    }
  }

  function createArrowsDepth(scene, objectPassed, textSpace, name, font) {
    const model = objectPassed.children[0].children[0];
    model.geometry.computeBoundingBox();
    const boundingBox = model.geometry.boundingBox;
    const depth = boundingBox.max.z - boundingBox.min.z;
    const middlePointZ = (boundingBox.min.z + boundingBox.max.z) / 2;
    const space = textSpace || 1;
    const halfSpace = space / 2.23;

    // Define dimensions for the body and head
    let headWidth = 0.1; // Adjust head width as needed
    let headHeight = 0.01; // Adjust head height as needed
    let bodyHeight = 0.008; // Body height

    // Calculate front and back body height
    const frontBodyHeight =
      boundingBox.max.z - middlePointZ - headHeight - 0.08;
    const backBodyHeight = middlePointZ - boundingBox.min.z - headHeight - 0.08;

    // Create body geometry for the front and back arrows
    const frontBodyGeometry = new THREE.PlaneGeometry(
      bodyHeight,
      frontBodyHeight
    );
    const backBodyGeometry = new THREE.PlaneGeometry(
      bodyHeight,
      backBodyHeight
    );
    const bodyMaterial = new THREE.MeshBasicMaterial({
      color: 0x2b87c9,
      side: THREE.DoubleSide,
    });

    // Create head geometry (as a rectangle)
    const headGeometry = new THREE.PlaneGeometry(headWidth, headHeight);
    const headMaterial = new THREE.MeshBasicMaterial({
      color: 0x2b87c9,
      side: THREE.DoubleSide,
    });

    // Create front arrow components
    const frontBody = new THREE.Mesh(frontBodyGeometry, bodyMaterial);
    frontBody.position.set(
      boundingBox.min.x - 0.1,
      boundingBox.min.y - 0.1,
      middlePointZ + frontBodyHeight / 1.1
    );
    frontBody.rotation.y = -Math.PI / 2;
    frontBody.rotation.z = Math.PI / 2;

    const frontHead = new THREE.Mesh(headGeometry, headMaterial);
    frontHead.position.set(
      boundingBox.min.x - 0.1,
      boundingBox.min.y - 0.1,
      boundingBox.max.z - headHeight / 2
    );
    frontHead.rotation.y = -Math.PI / 2;
    frontHead.rotation.z = Math.PI / 2;

    // Create back arrow components
    const backBody = new THREE.Mesh(backBodyGeometry, bodyMaterial);
    backBody.position.set(
      boundingBox.min.x - 0.1,
      boundingBox.min.y - 0.1,
      middlePointZ - backBodyHeight / 1.1
    );
    backBody.rotation.y = -Math.PI / 2;
    backBody.rotation.z = Math.PI / 2;

    const backHead = new THREE.Mesh(headGeometry, headMaterial);
    backHead.position.set(
      boundingBox.min.x - 0.1,
      boundingBox.min.y - 0.1,
      boundingBox.min.z + headHeight / 2
    );
    backHead.rotation.y = -Math.PI / 2;
    backHead.rotation.z = Math.PI / 2;

    // Retrieve size information
    const sizes = WardrobeSize.find((item) => item.name === name);
    if (!sizes) {
      return;
    }

    // Create text geometry
    const geometry = new TextGeometry(22 + '"', {
      font: font,
      size: 0.04,
      height: 0.001, // Thickness of the text
      curveSegments: 12,
      bevelEnabled: false,
    });

    geometry.center();

    const textDepth = new THREE.Mesh(geometry, bodyMaterial);
    textDepth.position.set(
      boundingBox.min.x - 0.1,
      boundingBox.min.y - 0.1,
      middlePointZ
    );
    textDepth.rotation.y = -Math.PI / 2;

    // Create a helper function to create rounded rectangle shapes
    function createRoundedRectShape(width, height, radius) {
      const shape = new THREE.Shape();
      shape.moveTo(-width / 2 + radius, -height / 2);
      shape.lineTo(width / 2 - radius, -height / 2);
      shape.quadraticCurveTo(
        width / 2,
        -height / 2,
        width / 2,
        -height / 2 + radius
      );
      shape.lineTo(width / 2, height / 2 - radius);
      shape.quadraticCurveTo(
        width / 2,
        height / 2,
        width / 2 - radius,
        height / 2
      );
      shape.lineTo(-width / 2 + radius, height / 2);
      shape.quadraticCurveTo(
        -width / 2,
        height / 2,
        -width / 2,
        height / 2 - radius
      );
      shape.lineTo(-width / 2, -height / 2 + radius);
      shape.quadraticCurveTo(
        -width / 2,
        -height / 2,
        -width / 2 + radius,
        -height / 2
      );
      return shape;
    }

    const bgW = 0.16;
    const bgH = 0.08;
    const borderWidth = 0.01;
    const borderColor = 0x2b87c9;
    const backgroundColor = 0xdbf0ff;
    const cornerRadius = 0.03; // Adjust this value for the desired corner radius

    // Create the rounded rectangle shape for the background
    const roundedRectShape = createRoundedRectShape(bgW, bgH, cornerRadius);
    const geometry1 = new THREE.ShapeGeometry(roundedRectShape);
    const material = new THREE.MeshBasicMaterial({ color: backgroundColor });
    const plane = new THREE.Mesh(geometry1, material);
    plane.position.copy(textDepth.position);
    plane.rotation.y = -Math.PI / 2;
    plane.renderOrder = 1; // Ensure the plane is rendered first

    // Create the rounded rectangle shape for the border
    const borderShape = createRoundedRectShape(
      bgW + borderWidth,
      bgH + borderWidth,
      cornerRadius
    );
    const borderGeometry = new THREE.ShapeGeometry(borderShape);
    const borderMaterial = new THREE.MeshBasicMaterial({ color: borderColor });
    const borderMesh = new THREE.Mesh(borderGeometry, borderMaterial);
    borderMesh.position.copy(plane.position);
    borderMesh.rotation.y = -Math.PI / 2;
    borderMesh.position.z -= 0.001; // Increase the separation to avoid Z-fighting
    borderMesh.material.depthWrite = false; // Prevent writing to the depth buffer

    // Add meshes to the scene
    scene.add(borderMesh);
    scene.add(plane);
    scene.add(textDepth);
    scene.add(frontBody);
    scene.add(frontHead);
    scene.add(backBody);
    scene.add(backHead);

    // Store references to the arrow components
    let depthArrows = [
      frontBody,
      backBody,
      frontHead,
      backHead,
      textDepth,
      borderMesh,
      plane,
    ];
    depthMes = depthArrows;
    Measurements.Depth.push(depthArrows);

    // Set depth visibility on reset
    for (let i = 0; i < Measurements.Depth.length; i++) {
      Measurements.Depth[i].forEach((d) => (d.visible = mesVisibility));
    }
  }

  //#endregion
}
window.addEventListener("resize", onWindowResize);
onWindowResize();
function onWindowResize() {
  const containerWidth = container.offsetWidth;
  const containerHeight = container.offsetHeight;

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  const devicePixelRatio = window.devicePixelRatio || 1;

  let newWidth, newHeight;

  const containerAspectRatio = containerWidth / containerHeight;
  const windowAspectRatio = windowWidth / windowHeight;
  let scaleFactor;

  if (windowAspectRatio > containerAspectRatio) {
    scaleFactor = Math.min(1, windowHeight / containerHeight);
  } else {
    scaleFactor = Math.min(1, windowWidth / containerWidth);
  }

  newWidth = containerWidth * scaleFactor;
  newHeight = containerHeight * scaleFactor;

  renderer.setSize(newWidth, newHeight);
  css2DRenderer.setSize(newWidth, newHeight);
  css3DRenderer.setSize(newWidth, newHeight);

  const aspectRatio = newWidth / newHeight;

  camera.aspect = aspectRatio;
  angleCamera.aspect = aspectRatio;
  angleCamera2.aspect = aspectRatio;

  angleCamera.updateProjectionMatrix();
  angleCamera2.updateProjectionMatrix();
  camera.updateProjectionMatrix();

  additionalCamera.left = (frustumSize * (newWidth / newHeight)) / -2;
  additionalCamera.right = (frustumSize * (newWidth / newHeight)) / 2;
  additionalCamera.top = frustumSize / 2;
  additionalCamera.bottom = frustumSize / -2;
  additionalCamera.updateProjectionMatrix();
}

function updateControlsToViewAllTowers() {
  const group = new THREE.Group();
  const centerVec = new THREE.Vector3();
  const sizeVec = new THREE.Vector3();
  const distanceVec = new THREE.Vector3();

  scene.traverse(function (node) {
    if (node instanceof THREE.Mesh) {
      if (node.name) return;
      const newMesh = node.clone();
      newMesh.updateMatrix();
      group.add(newMesh);
    }
  });

  if (!group.children.length) return;

  const bbox = new THREE.Box3().setFromObject(group);
  bbox.getCenter(centerVec);
  bbox.getSize(sizeVec);

  if (centerVec.y < 1) {
    centerVec.y = 1;
  }

  distanceVec.copy(centerVec);

  const camTargetPos = new THREE.Vector3(
    centerVec.x,
    centerVec.y,
    5 + sizeVec.x * 2
  );

  if (camera.position.distanceTo(camTargetPos) < 0.01) {
    updateCam = false;
    controls.enableRotate = true;
    controls.enableZoom = true;
  }

  const isInstant =
    typeof MoveCamInstant !== "undefined"
      ? !!MoveCamInstant
      : document.App && typeof document.App.getCameraMoveInstant === "function"
      ? !!document.App.getCameraMoveInstant()
      : false;

  if (updateCam) {
    controls.enableRotate = false;
    controls.enableZoom = false;
    if (isInstant) {
      // Snap instantly to the target without lerp
      camera.position.copy(camTargetPos);
      controls.target.copy(centerVec);
      angleControls.target.copy(centerVec);
      angleControls2.target.copy(centerVec);
      angleCamera2.position.x = centerVec.x;
      controls.maxDistance = 10 + sizeVec.x * 2;
      angleControls.minDistance = 5 + sizeVec.x;
      angleControls.maxDistance = 5 + sizeVec.x;
      angleControls2.minDistance = 5 + sizeVec.x;
      angleControls2.maxDistance = 5 + sizeVec.x;
      updateCam = false;
      controls.enableRotate = true;
      controls.enableZoom = true;
    } else {
      camera.position.lerp(camTargetPos.clone(), 0.1);
      controls.maxDistance = 10 + sizeVec.x * 2;
      controls.target.lerp(centerVec, 0.1);
      angleControls.target.lerp(centerVec, 0.1);
      angleControls.minDistance = 5 + sizeVec.x;
      angleControls.maxDistance = 5 + sizeVec.x;
      angleCamera2.position.x = centerVec.x;
      angleControls2.target.lerp(centerVec, 0.1);
      angleControls2.minDistance = 5 + sizeVec.x;
      angleControls2.maxDistance = 5 + sizeVec.x;
    }
  } else {
    controls.maxDistance = 10 + sizeVec.x * 2;
    controls.target.lerp(centerVec, 0.1);
    angleControls.target.lerp(centerVec, 0.1);
    angleControls.minDistance = 5 + sizeVec.x;
    angleControls.maxDistance = 5 + sizeVec.x;
    angleCamera2.position.x = centerVec.x;
    angleControls2.target.lerp(centerVec, 0.1);
    angleControls2.minDistance = 5 + sizeVec.x;
    angleControls2.maxDistance = 5 + sizeVec.x;
  }
}

function createCloset() {
  document.App.addBigWardrobeToScene(
    "16.5/16.5W_TOWER",
    document.App.positions[`16.5/16.5W_TOWER`]
  );
  document.App.addBigWardrobeToScene(
    "34.5/34.5W_TOWER",
    document.App.positions[`34.5/34.5W_TOWER`]
  );
  // document.App.addObjectToSelectedCabinet("Two_Drawers_D22_W30", 0);
  // document.App.addObjectToSelectedCabinet("Two_Drawers_D22_W30", 1);
  // document.App.addObjectToSelectedCabinet("One_Adjustable_Shelves_D22_W30", 5);
  // document.App.addBigAdditionalCabinetF(
  //   "Wardrobe_D22_W30",
  //   document.App.positions["Wardrobe_D22_W30"]
  // );
  // document.CabinetVars.SelectedIndex = 1
  // document.App.addObjectToSelectedCabinet('One_Adjustable_Shelves_D22_W30', 0);
}

function animate() {
  requestAnimationFrame(animate);
  controls.update();
  angleControls.update();
  angleControls2.update();
  updateControlsToViewAllTowers();

  css3DRenderer.render(scene, camera);
  renderer.render(scene, camera);
}
